const API_KEY = 'AIzaSyDzWKHZEKpv64ee1gHR3Y5Cp5lP1HTaaHs';
var stickyTop;
var $blogside;

function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}
// ----------------------------------------------------------------------------------------------------
// DOCUMENT (DOM) READY
// ----------------------------------------------------------------------------------------------------
$(document).ready(function() {
  
  $(function() {
    if ('ontouchstart' in document.documentElement) {
      $('body').addClass('touch-device');
      $('body').removeClass('mouse-device');
    } else {
      $('body').removeClass('touch-device');
      $('body').addClass('mouse-device');
    }
  }());

  // Common Site-Wide Functionality
  common.bindExpandCollapse();
  common.initHeaderScrollChange();
  common.bindNavigationMenu();
  common.setupLightboxes();
  common.setupRequiredFormFields();
  common.commonMisc();
  common.setupSliders();

  // Product Page
  if ( $('body.product').length || $('body.product\\.alt1').length || $('body.product\\.alt2').length ) {
    productpage.handleVariants();
    productVariants.addPricesToSelectOptions();
    productpage.initProductSelect();
    productpage.initTabs();
    productpage.initZoom();
  }

  // Brand Ambassadors Page
  if ( $('body.page\\.brandambassadors').length ) {
    brandAmbassadors.initPage();
  }
  
}); // End Document Ready ---------------

// ----------------------------------------------------------------------------------------------------
// Starting to organize JS features into object literals
// ----------------------------------------------------------------------------------------------------

// SHIPPING WINDOW (OUT OF STOCK) ======================================
var outOfStock = {
  
  selectedOption:  null,  // actual <option> element. jquery object.
  variantID: 		 null,  // Shopify's variant ID value, on selectedOption
  displayOosMsgEl: null,	// Main element for displayed out of stock message.

  // Find selected product. 
  findSelectedOption: function() {
    // set "selectedOption" and then "variantID"
    selectedOption = $("#variant-select").find('option').filter(':selected');
  
    // Get variant ID from selected <option> (hidden element).
    // Or if single product, get from input value
    outOfStock.variantID = null;
    if ( selectedOption.length > 0 && typeof selectedOption !== "undefined" ){
      outOfStock.variantID = selectedOption.attr('value');
    } else {
      outOfStock.variantID = $("input[name='id']").attr('value');
    }
  },

  // Find element that displays OOS message
  findMessageElement: function(){
    if (outOfStock.displayOosMsgEl == null || outOfStock.displayOosMsgEl.length <= 0) {
      outOfStock.displayOosMsgEl = $('article.product .oos-mg-info');
      if (outOfStock.displayOosMsgEl == null || outOfStock.displayOosMsgEl.length <= 0) {
        console.log("Notice: Could not find out of stock message's container element.");
      }
    }
  },

  // Find text to show for delayed shipping
  setOutOfStockMessage: function() {
    outOfStock.findSelectedOption();
    outOfStock.findMessageElement();

    if (outOfStock.variantID != "undefined" && outOfStock.variantID != null) {
      // there are elements for each variant's OOS message, corresponding with ID
      // Store OOS message for this particular variant:
      var oosName = '#oos-msg-' + outOfStock.variantID;
      var oosHiddenMsgContainer = $(oosName);
      var oosMsg = '';
      if (oosHiddenMsgContainer.length > 0) {
        oosMsg = oosHiddenMsgContainer.html();
      } 

      // If variant has an out of stock message, put it in the main element.
      // Otherwise hide the out of stock message and clear text from it.
      if (outOfStock.displayOosMsgEl.length > 0 && oosMsg.length > 0) {
        // Show the message to the user.
        outOfStock.displayOosMsgEl.css('display', 'block');
        outOfStock.displayOosMsgEl.find('.the-msg').html(oosMsg);
      } else {
        // Hide the message from the user.
        outOfStock.displayOosMsgEl.css('display', 'none');
        outOfStock.displayOosMsgEl.find('.the-msg').html('');
      }
    }
  }
};

// VARIANT HANDLING ===============================================================
var productVariants = {
  
  variantSelector : '#variant-select',
  
  // Find selected Option within variant Select element 
  getSelectedOption: function() {
    return $(productVariants.variantSelector).find('option').filter(':selected');
  },

  // Update swatch color text
  updateSwatchColorText: function(colorName) {
    var $colorContainer = $('form .colors');
  	if (colorName == 'Blue'){ colorName = 'Navy Blue'; }
    $colorContainer.find('span.colorname').text(colorName);
  },
  
  
  // Change Product Price to reflect selected variant
  checkForChangePrice: function(variantID) {
    console.log(variantID);
    if ( typeof variantID != "undefined" && variantID != null ){
      
      // Price Area - Use hidden price for this variant
      var $variantprice = $('.prodPrice .variantprice[data-variantid="' + variantID + '"]');
      if ( typeof $variantprice != "undefined" && $variantprice != null && $variantprice.length > 0 ){
        // Change main price area
        // $('#price .defaultprice, #price .variantprice').hide();
        // $variantprice.show();
        $('.prodPrice .defaultprice, .prodPrice .variantprice').addClass('hide-price');
        $variantprice.removeClass('hide-price');
      }
      
      // Compare at price
      var $compareprice = $('.prodPrice .RRP[data-variantid="' + variantID + '"]');
      console.log($compareprice)

      // $('.prodPrice .RRP, .prodPrice .default-RRP').hide();
      $('.prodPrice .RRP, .prodPrice .default-RRP').addClass('hide-price');
      if ( typeof $compareprice != 'undefined' && $compareprice != null && $compareprice.length > 0 ) {
    
        // Change main price area
        // $compareprice.show();
        //$('.prodPrice .RRP, .prodPrice .default-RRP').addClass('hide-price');
        $compareprice.removeClass('hide-price');
      }
    }
  },
  
  // Tack on price to variant options in select menu, for certain products.
  // May re-fire when currency changes, replacing existing price after en dash.
  addPricesToSelectOptions: function() {
    
    if ( $('#variant-select').hasClass('options-with-price') ) {
      $(".prodPrice .variantprice[data-variantid]").each(function(index, element) {

        var variantID = $(this).attr('data-variantid');
        var newPriceText = $(this).text();

        // Append new price to option. If it exists, replace existing.
        var existing = $('#variant-select [value="'+variantID+'"]');

        if (existing != null && existing.length > 0){
          var existingText = $(existing).text();
          var newText = existingText
          var indexOfDash = existingText.lastIndexOf('–');

          if (indexOfDash !== -1){
            newText = existingText.substring(0, indexOfDash - 1);
          } 

          newText = newText + ' – ' + newPriceText;
          $(existing).text(newText);
        }
      });
    }
  },
  
  // Change out description area by unhiding extra description, if variant is using that custom field.
  // E.g. used for stationary products
  checkForExtraDesc: function(variantID){
    if ( typeof variantID != "undefined" && variantID != null ){
      // See if extra description hidden div exists matching ID. 
      var $extra = $(".product-desc .extra-desc[data-variantid='" + variantID + "']");
      if ( typeof $extra != "undefined" && $extra != null && $extra.length > 0 ){
        // Unhide it and hide others.
        $('.product-desc .default, .product-desc .extra-desc').hide();
        $extra.show();
      } else {
        // Show default
        $('.product-desc .extra-desc').hide();
        $('.product-desc .default').show();
      }
    }
  }

};

// COMMON/GENERAL SITE-WIDE FUNCTIONS ==============================================
var common = {
  
  // Expand/Collapse Areas used throughout site
  bindExpandCollapse: function() {
    $('.accGroupTrigger').on('click',function(e) {
      var parent = $(this).parent('.accGroup');
      e.preventDefault();
      parent.toggleClass('open');
    });

    // PRODUCT Expand/Collapse Areas    
    // Expand/Collapse via clicking heading
    $('.expand > h4').on('click',function(e) {
      e.preventDefault();
      
      $expand_container = $(this).parent();
      $area = $expand_container.find('.area');
      
      $('.expand > .area').not($area)
      	.slideUp()
      	.parent()
      		.removeClass('open');
      
      $expand_container.toggleClass('open');
      $area.slideToggle();
      
      // update the aria-expanded attribute of the region
      if ( $expand_container.hasClass('open') ) {
        $expand_container.attr('aria-expanded', 'true');
      } else {
		    $expand_container.attr('aria-expanded', 'false');
      }
    });
  
 	  // SHOP mobile nav expand/collapse
  	$('a.filter-products').on('click',function(e) {
    	$('.shop-nav').toggleClass('open');
      $(this).toggleClass('open');
    	e.preventDefault();
    });


    // FAQ and Retailers Expand/Collapse. Dynamically add containers.
    $('article#customer-service div.withexpands h3, article#retailers h3').each(function() { 
      var $set = $(this).nextUntil('h3, h2, a.anchor');
      $set.wrapAll('<div class="expand" />');
    });
    // initially hide expanding containers that were added above
    $('article#customer-service .expand, article#retailers .expand').hide();
  
	// click on headings to expand next hidden container
    $('article#frequently-asked-questions h3').on('click',function(e){
      e.preventDefault();
      $heading = $(this);
      $nextExpand = $heading.next('.expand');
      $heading.toggleClass('open');
      $('article#frequently-asked-questions h3').not($(this)).removeClass('open');
      $('article#frequently-asked-questions .expand').not($nextExpand).removeClass('open').slideUp();
      
      // hidden container exists, slide it open 
      if ($nextExpand.length > 0) {
        $nextExpand
          .toggleClass('open')
          .slideToggle( function(){
            // touch screens, scroll to top of clicked item
          	if (e.type == 'touchend'){
              $('html, body').animate({
                  scrollTop: $heading.offset().top - 46
              }, 300);
            }
          });
      }
      $heading.parent()
        .toggleClass('open')
        .find('.area').slideToggle();
    });
  
	// Trigger click on FAQ heading if accessed via the anchor link
	var anchorInURL = $(location).attr('hash');
    if (anchorInURL) {
      $('article#frequently-asked-questions h3' + anchorInURL).trigger('click');
    }
  
  },

  initHeaderScrollChange: function() {
    // LARGE HEADER TURNS TO SMALLER HEADER ON SCROLL.
    // Add or remove class from body. Pixel value is tall header height minus height of small header
    $(window).scroll(handleHeaderChange);
    $(window).resize(handleHeaderChange);
    handleHeaderChange();
    
    function handleHeaderChange(){
      var scrollTop = $(window).scrollTop();
      
      // SCROLLED HEADER
      if (scrollTop >= 490) {
      	$('body').addClass('scrolled-header');
      } else { 
      	$('body').removeClass('scrolled-header');
      }
    }
    
  },

  // Main Navigation Bar (Mobile Menu)
  bindNavigationMenu: function() {
    var siteHeader = $('.siteHeader');
    var searchItem = $('.searchTrigger');
    var searchWrap = searchItem.parents('.headerSearch');
    var searchBtn = searchWrap.find('.searchDropSubmit');
  
	  // Button to open mobile menu
    $('a.opengrid, .getstarted .tooltip, .menuTrigger').on('click', function(e) {
      var open = siteHeader.data('open');
      $(this).toggleClass('mod-open');

      /* expand and collapse */
      if ($(window).width() <= 1120) {
        if (open) {
          // CLOSE GRID
          siteHeader.removeClass('open');
          siteHeader.data('open', false);
          $('body').removeClass('menu-open');
        } else {
          // OPEN GRID
          startingHeaderHeight = $('.siteHeader').outerHeight();
          siteHeader.addClass('open');
          siteHeader.data('open', true);
          $('body').addClass('menu-open');
        }
      }
      e.preventDefault();
    });

    // Close nav bar, if it was open, and window is big enough
    $(window).resize(function() {
      if ($(window).width() > 767) {
        var grid = $('.siteHeader');
        var open = grid.data(open);
        if (open) {
          $('.menuTrigger').trigger('click');
        } else {
          $('#branding').removeAttr('style');
        }
      }
    });

    $('.navDrawerClose').on('click', function(e) {
      $('.siteHeader').removeClass('open');
      $('body').removeClass('menu-open');
      $('.siteHeader').data('open', false);
    });
    
    if (searchItem.length > 0) {
      // On click, unhide the form and focus in the input
      searchItem.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // searchWrap.toggleClass('search-visible');
        // searchWrap.find('input')[0].focus();
        siteHeader.removeClass('open');
        siteHeader.data('open', false);
      });
      // On blur, close search input. As long as blur wasnt from click on search icon.
      searchWrap.find('input').on('focusout', function(e) {
        if (!e.relatedTarget || !$(e.relatedTarget).is(searchBtn) || !$(e.relatedTarget).is(searchItem)) {
          searchWrap.removeClass('search-visible');
        }
      });
    }
    
  }, // end bindNavigationMenu
  
  
  
  // Bind Colorbox to various links
  setupLightboxes: function(){
    
    // Colorbox, generic -----------------------
    $("a[rel='colorbox'], a[rel='colorbox2'], a[rel^='colorbox']").colorbox({
      maxWidth:'85%',
      maxHeight:'85%', 
      loop: false,
      opacity:1,
      onComplete: function(){
          $('#cboxLoadedContent').zoom({ 
              on: 'click'
          });
      }
    });
    
    // Colorbox, generic HTML content
    $("a[rel='cboxcontent']").colorbox({
      maxWidth:900,
      maxHeight:'85%', 
      inline:true, 
      href: $(this).attr('href')
    });
    
    // Newsletter signup popup
    $("#newsletter-signup, input.newsletter-signup, #newsletter-signup-drop").colorbox({
      maxWidth:'85%',
      maxHeight:'85%', 
      opacity:1,
      inline: true,
      href: "#mc_embed_signup"
    });
    
    // Newsletter signup - pass single email field to popup form
    $("#newsletter-signup, #newsletter-signup-drop, input.newsletter-signup").on("click", function(e){
      $('#mc_embed_signup input[name="EMAIL"]').val( $(this).prev('input[name="subscribe"]').val() );
      e.preventDefault();
    });
    
  }, // end setupLightboxes
  
  
 
  // REQUIRED FORM FIELDS (site-wide)
  // Mark required fields when form is submitted and fields are not set
  setupRequiredFormFields: function(){
    
    $('form').submit(function() {     	
      
      // Add "error" class to fields with "required" attribute, if empty.
      var faults = $('input,textarea,select', this)
      	.filter(function() {
          // filter input elements to required ones that are empty
          return $(this).data('required') && ( $(this).val() === "" || $(this).val() === $(this).attr('title')  );
        })
      	.addClass('error');

      // If required fields were found that were empty, cancel form submission
      if(faults.length) { 
        return false;
      } else {
        // Form can be submitted. Close open colorboxes (for newsletter signup popup):
        parent.jQuery.fn.colorbox.close();
      }
      
    });
    
  }, // end setupRequiredFormFields
  
  
  
  // Miscellaneous small scripts. Site-wide.
  commonMisc: function() {

    // Bag - Update Quantities, trigger click on hidden input element
    $("#cartform .qty input.number").change(function(){
    	$("#update_quantities").trigger("click");
    });

    // old: Add anchor link class, that pads anchors so they dont go under top fixed bar
    $("article a[name]").addClass('anchor');
    
    // STICKY BLOG SIDEBAR - Fixed follow with scroll
    $blogside = $('#blog-posts figure.featured');
    if ($blogside.length > 0){
      stickyTop = $blogside.offset().top; // returns number 
      $(window).scroll(function(){ // scroll event  
        StickySidebar();
      });
    }
  
	  // Content fitvids: scale videos to fit content area width responsively
    $('.entry-content').fitVids();
  

    // WRAP BLOG IMAGES WITH FIGURE TAG AUTOMATICALLY
    $('body.article section.entry-content img').each(function( index, element ){
    if ( 
      ! $(this).parent('figure').length && 
      ! $(this).parent().parent('figure').length  && 
      ! $(this).hasClass('nofigure') ) 
    {
      $(this).wrap('<figure></figure>');
      $(this).parent('figure').parent('a').addClass('no-decoration');
    }
    });
  
  
    // SMOOTH SCROLL (troubadour for)
    $('a.smoothscroll').click(function(event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: $(this.hash).offset().top - 50
      }, 800);
    });

    // Change "Back to Store" link text on account pages
    $("body.customer .action_bottom .note a[href='http://www.troubadourgoods.com'], #return_to_store a[href='http://www.troubadourgoods.com']").attr('href','/collections/all');
    
  }, // end commonMisc
  
  // Slick Sliders
  setupSliders: function() {
    
    // Hero Slider
    $('.heroSlider').slick({
      mobileFirst: true,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 6500,
      pauseOnHover: false,
      useTransform: false
    });
    
    $('#product-photos').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
      // Set current slide number and total slides (mobile)
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $('#product-photos-nav .slider-count-current').text(i);
      $('#product-photos-nav .slider-count-total').text(slick.slideCount);
    });
    
    $('#product-photos').on('afterChange', function() {
      // jQuery Zoom
      $('.product-photo').trigger('zoom.destroy');
      productpage.initZoom();
  	});
    
    $('#product-photos').slick({
      mobileFirst: true,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      swipe: $('#product-photos .Magic360').length==0,
      lazyLoad: 'ondemand',
      dotsClass: 'product-slider-dots',
      appendDots: $('#product-photos-dots')
    });

    $('#product-thumbs').on('init', function(event, slick) {
      $('#product-thumbs .slick-slide.slick-current').addClass('is-active');
    }).slick({
      mobileFirst: true,
      dots: false,
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 7,
      arrows: true,
    });

    $('#product-photos').on('afterChange', function(slick, currentSlide) {
      var videos = $('#product-photos').find('video');
      var currVideo = $('#product-photos').find('[data-slick-index="'+currentSlide.currentSlide+'"] video');
      var currrentNavSlideElem = '#product-thumbs .slick-slide[data-slick-index="' + currentSlide.currentSlide + '"]';
      $('#product-thumbs').slick('slickGoTo', currentSlide.currentSlide);
      $('#product-thumbs .slick-slide.is-active').removeClass('is-active');
      $(currrentNavSlideElem).addClass('is-active');
      videos.each(function() {
        $(this).get(0).pause();
      });
      currVideo.each(function() {
        $(this).get(0).play();
      });
    });
   
    $('#product-thumbs .slick-slide').on('click', function(event) {
      var goToSingleSlide = $(this).data('slick-index');
      $('#product-photos').slick('slickGoTo', goToSingleSlide);
    });
    
    PointerEventsPolyfill.initialize({ selector: '#desktop-slider .click-to-zoom' });

    $logosSlider = false;
    function logosSlider() {    
      if ($(window).width() >= 601) {
        if (!$logosSlider) {
          $('.logosSlider').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              }
            ]
          });
          $logosSlider = true;
        }
      } else if ($(window).width() <= 600) {
        if ($logosSlider) {
          $('.logosSlider').slick('unslick');
          $logosSlider = false;
        }
      }
    };

    $(document).ready(function(){
      logosSlider();
    });
    $(window).on('resize', function(){
      logosSlider();
    });

    $('.logosSliderAff').slick({
      dots: false,
      infinite: true,
      speed: 300,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }
      ]
    });

    $('.imageColumnsSlider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });

    $('.retailers-slider .logos').slick({
      mobileFirst: true,
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 600,
          settings: {
          slidesToShow: 3,
      		slidesToScroll: 3, 
          }
        },
        {
          breakpoint: 800,
          settings: {
          slidesToShow: 4,
      		slidesToScroll: 4, 
          }
        },
        {
          breakpoint: 1120,
          settings: {
          slidesToShow: 3,
      		slidesToScroll: 3, 
          }
        },
        {
          breakpoint: 1240,
          settings: {
          slidesToShow: 4,
      		slidesToScroll: 4, 
          }
        }
      ]
    });

    $('#relatedProductsSlider').slick({
      mobileFirst: true,
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }
      ]
    });

    var swiper = new Swiper('.productCompareSlider', {
  slidesPerView: 1,
  spaceBetween: 10,
       navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});

    $('.productCompareSlidersection').slick({
      mobileFirst: true,
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 800,
          settings: "unslick"
        }
      ]
    });

    $('.productCompareSliderS').slick({
      mobileFirst: true,
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });

   $('.productInformationSlider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 1500,
      loop: true,
      fade: true
    });
  }
};


// PRODUCT PAGE FUNCTIONS =======================================================================
var productpage = {  
  // HANDLE PRODUCT VARIANTS AND COLOR SWATCHES ------------------------------------
  handleVariants: function() {
    
    
    // SELECT COLOR (VARIANT)
    // Change hidden select list, when alt color images are clicked
    var $variantSelect = $("#variant-select");
    var $colorContainer = $("form .colors");
    
    if ( $variantSelect.length > 0 ) {
      $variantSelect.prop('selectedIndex',0);

      if ( $colorContainer.length > 0 ) {
        $colorContainer.addClass('colorSelectActive');
        $colorContainer
          // .find('span.available .swatch')
          .find('.the-swatches .swatch')
          .click(function() {
          
            // CHANGE COLOR / VARIANT
            // Active styling
            $colorContainer.find('.swatch').parent('span').removeClass('selected');
            $(this).parent('span').addClass('selected');
          
            // Activate same clicked color in SELECT > OPTION, as is set on the alt atttribute
            var theColor = $(this).attr('data-variant-title');
            var theColorDisplay = $(this).attr('data-alt');
          
            $variantSelect
              .find('option')
              .filter(function(){ return $(this).attr('data-fulltitle') === theColor; })
              .prop('selected', true)
              .change();
            
            // Add color name from ALT as text
            productVariants.updateSwatchColorText(theColorDisplay);
        });
      }
    } else {
      // Still want color name, for single color.
      if ( $colorContainer.length > 0 ) {
        var $singleIMG = $colorContainer.find('span.available .swatch').first();
        // Add color name from ALT as text.
        var theColor = $singleIMG.attr('data-alt');
        productVariants.updateSwatchColorText(theColor);	
      }
    }
  
    if ( $colorContainer.length > 0 ){
      var $firstColor = $colorContainer.find('span.available').first();
      if ( $firstColor.length > 0 && $colorContainer.find('span.selected').length == 0 ){
      	$firstColor.addClass('selected');
        var theFirstColor = $firstColor.find('.swatch').attr('data-alt');
        productVariants.updateSwatchColorText(theFirstColor);
      }
      // simulate click on first item, if none selected
	   $colorContainer.find('span.available .swatch').first().trigger('click');
    }

  
	// SELECTED VARIANT HAS CHANGED
    // Also triggers on load
    $('#variant-select').change(function(){
   
      var $selectedOption = productVariants.getSelectedOption();
      
      // Get variant ID from selected <option> (hidden element).
      // Or if single product, get from input value
      var variantID = null;
      if ( $selectedOption.length > 0 && typeof $selectedOption !== "undefined" ){
      	variantID = $selectedOption.attr('value');
      } else {
        variantID = $("input[name='id']").attr('value');
      }
      
      // SHIPPING WINDOW (OUT OF STOCK) - Find text to show for delayed shipping
	    outOfStock.setOutOfStockMessage();
      
      // CHANGE DISPLAYED PRICE TO REFLECT VARIANT
      productVariants.checkForChangePrice(variantID);
      
      // IF USING METAFIELD FOR VARIANT DESCRIPTION, SWITCH IF NECESSARY
      productVariants.checkForExtraDesc(variantID);
      
	  // CHANGE SLIDER IMAGE TO VARIANT IMAGE, WHEN VARIANT SELECT VALUE CHANGES
      var variantImgSrc = null;
      var variantimgUrl = null;
      if ( $selectedOption.length > 0 && typeof $selectedOption !== "undefined"){
      	variantImgSrc = $selectedOption.data('variantphoto');
        variantimgUrl = $selectedOption.data('variantphoto-url');
      }
      
      if ( typeof variantImgSrc !== "undefined" && variantImgSrc != null ) {
        // Change slider to variant image. 
        // Matched up by data-imgsrc in slider and data-variantphoto in <option>
        if ( $('.product-photos.slick-slider').length > 0 ) {          
          // Replace source of second image in the slider, which is always the variant image.
          if (variantimgUrl !== null) {
            $('.product-photos .product-variant-photo img').removeAttr('data-lazy').attr('src', variantimgUrl);
            $('#product-thumbs .product-variant-photo img').removeAttr('data-lazy').attr('src', variantimgUrl);
            var variantPhotoSliderIndex = $('.product-photos .product-variant-photo:not(.slick-cloned)').data('slick-index');
            
            console.warn(variantPhotoSliderIndex)
            
            // Change slider to that image
            var theSlider = $('.product-photos.slick-slider:visible');
            var theSliderThmb = $('#product-thumbs.slick-slider:visible');
            if (theSlider.length > 0) {
              theSlider.slick('slickGoTo', parseInt(variantPhotoSliderIndex));
              theSliderThmb.slick('slickGoTo', parseInt(variantPhotoSliderIndex));
            }
          }
        }

        // CHANGE SELECTED SWATCH, IF DIFFERENT 
        // Because the variant may have been changed through a direct link to the variant in the URL
        if ( $('.colorSelectActive span.selected > .swatch[data-imgsrc="'+variantImgSrc+'"]').length == 0 ) {
			    $('.colorSelectActive span').removeClass('selected');
          var $newSelected = $('.colorSelectActive span.available > .swatch[data-imgsrc="'+variantImgSrc+'"]').parent('span.available');
          $newSelected.addClass('selected');
        	productVariants.updateSwatchColorText( $newSelected.find('.swatch').attr('data-alt') );
        }
      }
      
      
      
      if (!variantID) {
        return;
      }
      
      
      var newUrl = location.pathname + '?variant=' + variantID;
      window.history.replaceState({path: newUrl}, '', newUrl);

    });
    //.triggerHandler('change');
    
    var $selectedOption = productVariants.getSelectedOption();
    var variantId = null;
    if ( $selectedOption.length > 0 && typeof $selectedOption !== "undefined" ){
      variantId = $selectedOption.attr('value');
    } else {
      variantId = $("input[name='id']").attr('value');
    }

    if (variantId) {
      productVariants.checkForChangePrice(variantId);
    }
  
  	// Also set out of stock message on load. Because single items do not have <select>, just an input.
  	outOfStock.setOutOfStockMessage();
    
    
  }, // end handleVariants  
  
  // Ability to link to specific variants using hash to SKU in URL ----------------
  // e.g. https://www.mujjo.com/products/stationery-set#1039BL01AW16
  // (Note: Don't run until sliders loads)
  initProductSelect: function() {
    if(window.location.hash) {

      var sel = $('#variant-select');
      var hash = window.location.hash.substring(1);

      // Change variant Select element to one with matching SKU in URL hash
      sel.find('option').each(function() {
        var t = $(this);
        if(t.attr('data-sku') == hash)
        {
          t.prop('selected', true);
          sel.trigger('change');
        }
      });
    }
    
    
    if(window.location.search.indexOf('?variant=') === 0) {
      var variantId = window.location.search.split('?variant=')[1];
      if (!variantId) {
        return;
      }
      
      $('#variant-select option[value="' + variantId + '"]').prop('selected', true);
      $('#variant-select').trigger('change');
    }
  },
  
  
  // PRODUCT DETAIL - TABS -------------------------------
  initTabs: function(){
    var tabs = $('.tabs');
    if (tabs.length > 0) {
      tabs.find('nav li').on('click', function(){
        // Set active tab nav item
        tabs.find('nav li').removeClass('active');
        $(this).addClass('active');
        
        // Show tab content based on data attribute
      	var tabID = $(this).data('tab-id');
        if (typeof tabID !== 'undefined' && tabID !== null){
          var newTab = tabs.find('.tabs-content[data-tab-id="'+ tabID +'"]');
          tabs.find('.tabs-content').removeClass('active');
          newTab.addClass('active');
        }
      });
    }
  },  

  // JQUERY ZOOM ON PRODUCT PHOTOS -------------------------
  initZoom: function() {
    if (isTouchDevice()) {
      $('.mobileZoomer').magnifik();
    }
    var zoomBtn = $('.click-to-zoom:not(.inZoom)');
    if (!isTouchDevice()) {
     
      $('#product-photos .product-photo .mobileZoomer').ZooMove({
        scale: '1.75',
      });

      $('.mobileZoomer').on('click', function(e) {
        e.preventDefault();
      })
    }
  }

  
}; // end productpage

// BRAND AMBASSADORS PAGE FUNCTIONS =======================================================================
var brandAmbassadors = {
  
  initPage: function() {

    //BRAND AMBASSADORS
    //Back to top
    $('a.top').click(function(event){
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 800);
    });

    //Open Q&A's using anchor in URL
    if(window.location.hash) {
        var hash = window.location.hash;
    }

    //Reveal Q&A's
    $('a.read-qa').click(function(event){
        event.preventDefault();
        $('a.read-qa > span.read-more').text('View Q & A');
        $('span.read-more', this).text('Viewing Q & A');

        //Variables
        var viewportWidth = $(window).width();
        var readqaID = $(this).attr('id');
        var qaContainer = $('.question-answer#' + readqaID);
        var personCount = $(this).parent().index('.person') + 1;

        //Reveal Q&A
        function toggleQA() {
            if($(qaContainer).is(":visible")){
                //Do nothing
            }
            else {
                $('.question-answer').hide();
                $(qaContainer).stop(true, true).show(0);
                $('html, body').stop(true, true).animate({scrollTop:$(qaContainer).offset().top - 300}, 600);
            }
        }

        //Update viewport width on resize
        function checkWidth (){
            var viewportWidth = $(window).width();
        }
        $(window).resize(checkWidth);

        //Selected States
        $('a.read-qa').removeClass('selected');
        $(this).addClass('selected');

        //Insert Q&A Container
        if (viewportWidth >= 992){
            $(this).closest('.row').after(qaContainer);
            toggleQA();
        }
        else if (viewportWidth >= 500){
            if (personCount % 2 == 0){
                //Even
                qaContainer.insertAfter($(this).parent());
                toggleQA();
            }
            else {
                //Odd
                qaContainer.insertAfter($(this).parent().next());
                toggleQA();
            }
        }
        else {
            qaContainer.insertAfter($(this).parent());
            toggleQA(); 
        }
    }); 
    
  }

}

$(document).ready(function() {
  function handleCollFilters() {
    var sortByParam = location.search.split('sort_by=')[1];
    if (!sortByParam) {
      $('.coll-nav--clear.coll-nav--clear-main').removeClass('d-lg-block');
    } else {
      $('.accordGroupToggle .accordItem > ul > li > a:not(.sortByLink)').each(function() {
        var href = $(this).attr('href');
        var newHref = href + '?sort_by=' + sortByParam;
        $(this).attr('href', newHref)
      })
    }
    $('.sortByLink').each(function() {
      var url = $(this).attr('href');
      if (sortByParam) {
        if($(window).width >= 1000) {
          $(this).parents('.accordGroupToggle').addClass('active activeOnLoad');
        } else {
          $(this).parents('.accordGroupToggle').removeClass('active');
        }
        if (url.includes(sortByParam)) {
          $(this).addClass('current');
        }
      }
    });
    
    if ($(window).width() < 1000) {
      $('.accordGroupToggle').removeClass('active');
    } else {
      $('.accordGroupToggle.activeOnLoad').addClass('active');
    }
  }
  
  // Hide Klarna info for non-USA users
  $.getJSON(
    'https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572', 
    function(data) {
      var klarnaIframeToHide = $('#findKlarnaIframe');
      if ( data.country_code === "US" || data.country_name === "United States" ) {
      } else {
        if ( klarnaIframeToHide.length ) {
          klarnaIframeToHide.addClass('non-usa-user');
        }
      }
    }
  );

  // Append corresponding megamenus to top-level links
  $(function() {
    var mMenus = $('.mMenu');
    mMenus.each(function() {
      var nth = $(this).data('menu-item');
      var menuParItem = $('#mMenuParentNav > li:nth-child(' + nth + ')');
      $(this).appendTo(menuParItem);
    });
  });
  
  // Show megamenu item's image
  $(function() {
    $('.mmenuLink').each(function() {
      var mParent = $(this).parents('.mMenu');
      var dataId = $(this).data('item-id');
      var mImges = mParent.find('.mMenuImage');
      var mImg = mParent.find('.mMenuImage[data-id="' + dataId + '"]');
      $(this).hover(function() {
        mImges.removeClass('current');
        mImg.addClass('current');
      }, function() {
        // Nothing
      })
    })
  });
  
  // Hide menu on menu outside area click
  $('#mMenuBackdrop').on('click', function() {
    $('body').removeClass('menu-open');
    $('.siteHeader').removeClass('open');
  });
  
  $(function() {
    function setScreenSizeClass() {
      if (1121 > $(window).width()) {
        $('body').addClass('mobile-screen');
        $('body').removeClass('desktop-screen');
      } else {
        $('body').removeClass('mobile-screen');
        $('body').addClass('desktop-screen');
      }
    }
    setScreenSizeClass();
    $(window).resize(function() {
      setScreenSizeClass();
    });
  }());

  $('.navDrawer').each(function() {
    var tabs = $(this).find('.navDrawerTab');
    var groups = $(this).find('.navDrawerGroup');
    tabs.on('click', function() {
      var index = $(this).index();
      var otherTabs = $(this).siblings('.navDrawerTab');
      var groupToOpen = $(groups[index]);
      otherTabs.removeClass('active');
      $(this).addClass('active');
      groups.removeClass('active');
      groupToOpen.addClass('active');
    });
  });
  $('.navDrawer .navDrawerTab').first().click();

  $('.touch-device [data-toggle="dropdown"]').on('click', function(e) {
    var parent = $(this).parents('.dropdown');
    e.preventDefault();
    parent.toggleClass('active');
  });

  $('.filtersGroupsClose').on('click', function(e) {
    var parent = $(this).parents('.filtersGroups');
    var filterGroup = parent.find('.filterGroup');
    parent.removeClass('open');
    filterGroup.removeClass('open');
  })

  $('.accordHead').each(function() {
    $(this).on('click', function(e) {
      var mainParent = $(this).parents('.accordGroup');
      var parent = $(this).parents('.accordGroupToggle');
      var dTarget = $(this).data('target');
      var siblings = mainParent.find('.accordGroupToggle:not([data-id="' + dTarget + '"])');
      parent.toggleClass('active');
      siblings.removeClass('active');
    });
  });

  $('.filterGroup').each(function() {
    var $this = $(this);
    var parennt = $(this).parent('.filtersGroups');
    var trigger = $(this).find('.filterGroupBtn');
    var sibblings = $(this).siblings('.filterGroup');
    trigger.on('click', function(e) {
      parennt.addClass('open');
      sibblings.removeClass('open');
      $this.toggleClass('open');
    });
  });

  handleCollFilters();

  if($(window).width() >= 1000) {
    var clickerElement = $('.accordHeadFilter');
    var activeElements = $('.accordGroupToggle.active');
    if (activeElements.length === 0 && clickerElement[0]) {
      clickerElement[0].click();
    }
  }

  $('.addToBagTrigger').on('click', function() {
    var proofAddToBag = $('#add_to_basket');
    if (proofAddToBag.length) {
      proofAddToBag.submit();
    }
  });

  function offset(el) {
    var rect = el.getBoundingClientRect();
    return { 
      top: rect.top,
      left: rect.left,
    }
  }

  function stickAddToCart() {
    var addToBag = $('#add-to-bag');
    if (addToBag.length > 0) {
      var offfset = addToBag.offset().top;
      if ( $(document).scrollTop() >= offfset ) {
        $('body').addClass('sticky-addtocart');
      } else {
        $('body').removeClass('sticky-addtocart');
      }
    }
  }
  stickAddToCart();

  $(document).scroll(function() {
    stickAddToCart();
  });

  
  $(window).resize(function() {
    handleCollFilters();
  });

  function initRucksackSizeComparison() {
    equalizeItemsHeight();
    
    var container = document.querySelector('.rsComparison');
    window.shuffle = new Shuffle(container, {
      itemSelector: '.rsComparison__item:not(.sizer)',
      sizer: '.sizer',
      throttleTime: 400
    });
    
    shuffle.on(Shuffle.EventType.LAYOUT, function() {
      equalizeItemsHeight();
    });
    
    $('.rsComparison__sort__btn').click(function() {
      $(this).siblings('.rsComparison__sort__btn').removeClass('active');
      $(this).addClass('active');
      var type = $(this).data('type');
      shuffle.sort({
        compare: function(a, b) {
          var sizeA = a.element.getAttribute('data-size');
          sizeA = formatSize(sizeA, type);
          
          var sizeB = b.element.getAttribute('data-size');
          sizeB = formatSize(sizeB, type);
          
          if (type === 'asc') {
            return sizeA - sizeB;
          }
          
          return sizeB - sizeA;
        }
      });
      
    });
    
    var flag;
    $(window).resize(function() {
      flag = setTimeout(function() {
        clearTimeout(flag);
        equalizeItemsHeight();
      }, 300);
    });
    
    function equalizeItemsHeight() {
      var maxHeight = 0;
      var $items = $('.rsComparison__item:not(.sizer)');
      $items.height('');
      $items.each(function() {
        var itemHeight = $(this).outerHeight();
        if (itemHeight > maxHeight) {
          maxHeight = itemHeight;
        }
      });
      $items.height(maxHeight);
    }
    
    function formatSize(size, sortType) {
      if (!size) {
        return 0;
      }
      
      var parts = size.split('-');
      if (parts.length === 1) {
        return size;
      }
      
      if (sortType === 'asc') {
        return parts[0];
      }
      
      return parts[1];
    }
  }

  if ($('body.page\\.rucksack-size-comparison').length) {
    initRucksackSizeComparison();
  }
});

$(document).ready(function() {
  var currentCurrency = $('.currentCurrency');
  var currenciesList = $('.currenciesList');
  var availableCurrencies = $('#currency-list option');

  function submitSwitcherForm() {
    $('.locale-selectors__container form').submit();
  }

  if (availableCurrencies.length > 0) {
    availableCurrencies.each(function() {
      let vall = $(this).val();
      let txt = $(this).html();
    // var country = $(this).data('name');
      let name = $(this).data('name');
      let selected = $(this).prop('selected') ? ' active' : '';
      let fullName = name;
      if (selected) {
        currentCurrency.each(function() {
          var locationCookie = Cookies.get('cart_location');
          var prefix = $(this).data('prefix') ? $(this).data('prefix') : '';
          var currencyCodeShow = vall;
          if (locationCookie && locationCookie !== '') {
            var currencyCodeShow = locationCookie;
          }
          $(this).html('<span class="header-currencies--caption-pref mr-2 mr-md-1">' + prefix + '</span><span class="mr-2 mr-md-1 currency-flag currency-flag-' + currencyCodeShow.toLowerCase().replace(/\s+/g, '-') + '"></span>' + name);
        });
      }
      currenciesList.each(function() {
        if (fullName == 'Global (in USD)') {
          $(this).append('<div class="triggerCurrencyChange curr-list--item flex-align-center' + selected + '" data-val="' + vall + '"><span class="mr-2 currency-flag currency-flag-global"></span><span class="mobile-only curr-list--item-name">' + fullName + '</span><span class="desktop-only curr-list--item-name">' + fullName + '</span></div>')
        } else if (fullName == 'Rest of World') {
          $(this).append('<div class="triggerCurrencyChange curr-list--item flex-align-center' + selected + '" data-name="Rest of World" data-val="' + vall + '"><span class="mr-2 currency-flag currency-flag-global"></span><span class="mobile-only curr-list--item-name">' + fullName + '</span><span class="desktop-only curr-list--item-name">' + fullName + '</span></div>')
        } else if (fullName == 'Africa') {
          $(this).append('<div class="triggerCurrencyChange curr-list--item flex-align-center' + selected + '" data-name="Africa" data-val="' + vall + '"><span class="mr-2 currency-flag currency-flag-africa"></span><span class="mobile-only curr-list--item-name">' + fullName + '</span><span class="desktop-only curr-list--item-name">' + fullName + '</span></div>')
        } else {
          $(this).append('<div class="triggerCurrencyChange curr-list--item flex-align-center' + selected + '" data-val="' + vall + '"><span class="mr-2 currency-flag currency-flag-' + vall.toLowerCase() + '"></span><span class="mobile-only curr-list--item-name">' + fullName + '</span><span class="desktop-only curr-list--item-name">' + fullName + '</span></div>')
        }
      });
    });
  }

  $('.triggerCurrencyChange').on('click', function() {
    var vall = $(this).data('val');
    var country = $(this).data('name');
    if (country) {
      Cookies.set('cart_location', country);
    } else {
      Cookies.set('cart_location', '');
    }
    $('#currentCurrencyInp').val(vall);
    setTimeout(function() {
      $('#localization_form').submit();
    }, 100);
  });

  $('.videoBtn').each(function() {
    var $this = $(this);
    var wrap = $(this).parents('.videoBtnPlay');
    var video = wrap.find('video');
    if (video[0]) {
      var video = video[0];
      video.onplay = function () {
        wrap.addClass('is-playing');
      };
      video.onpause = function () {
        wrap.removeClass('is-playing');
      };
      $this.on('click', function() {
        wrap.addClass('is-playing');
        video.play();
      });
    }
  });

  $('.currSwitch').on('change', function(e) {
    var vall = $(this).val();
    $('.locale-selectors__selector').val(vall);
    submitSwitcherForm();
  });

  $(function() {
    var currencyForm = $('#localization_form');
    var currencySelect = currencyForm.find('#currency-list');
    var currencyInput = currencyForm.find('#currentCurrencyInp');

    var firstVisitCookie = Cookies.get('first_visit_cookie');
    var currencyCookie = Cookies.get('cart_currency');

    var rawList = '"BD": "BDT", "BE": "EUR", "BF": "XOF", "BG": "BGN", "BA": "BAM", "BB": "BBD", "WF": "XPF", "BL": "EUR", "BM": "BMD", "BN": "BND", "BO": "BOB", "BH": "BHD", "BI": "BIF", "BJ": "XOF", "BT": "BTN", "JM": "JMD", "BV": "NOK", "BW": "BWP", "WS": "WST", "BQ": "USD", "BR": "BRL", "BS": "BSD", "JE": "GBP", "BY": "BYR", "BZ": "BZD", "RU": "RUB", "RW": "RWF", "RS": "RSD", "TL": "USD", "RE": "EUR", "TM": "TMT", "TJ": "TJS", "RO": "RON", "TK": "NZD", "GW": "XOF", "GU": "USD", "GT": "GTQ", "GS": "GBP", "GR": "EUR", "GQ": "XAF", "GP": "EUR", "JP": "JPY", "GY": "GYD", "GG": "GBP", "GF": "EUR", "GE": "GEL", "GD": "XCD", "GB": "GBP", "GA": "XAF", "SV": "USD", "GN": "GNF", "GM": "GMD", "GL": "DKK", "GI": "GIP", "GH": "GHS", "OM": "OMR", "TN": "TND", "JO": "JOD", "HR": "HRK", "HT": "HTG", "HU": "HUF", "HK": "HKD", "HN": "HNL", "HM": "AUD", "VE": "VEF", "PR": "USD", "PS": "ILS", "PW": "USD", "PT": "EUR", "SJ": "NOK", "PY": "PYG", "IQ": "IQD", "PA": "PAB", "PF": "XPF", "PG": "PGK", "PE": "PEN", "PK": "PKR", "PH": "PHP", "PN": "NZD", "PL": "PLN", "PM": "EUR", "ZM": "ZMK", "EH": "MAD", "EE": "EUR", "EG": "EGP", "ZA": "ZAR", "EC": "USD", "IT": "EUR", "VN": "VND", "SB": "SBD", "ET": "ETB", "SO": "SOS", "ZW": "ZWL", "SA": "SAR", "ES": "EUR", "ER": "ERN", "ME": "EUR", "MD": "MDL", "MG": "MGA", "MF": "EUR", "MA": "MAD", "MC": "EUR", "UZ": "UZS", "MM": "MMK", "ML": "XOF", "MO": "MOP", "MN": "MNT", "MH": "USD", "MK": "MKD", "MU": "MUR", "MT": "EUR", "MW": "MWK", "MV": "MVR", "MQ": "EUR", "MP": "USD", "MS": "XCD", "MR": "MRO", "IM": "GBP", "UG": "UGX", "TZ": "TZS", "MY": "MYR", "MX": "MXN", "IL": "ILS", "FR": "EUR", "IO": "USD", "SH": "SHP", "FI": "EUR", "FJ": "FJD", "FK": "FKP", "FM": "USD", "FO": "DKK", "NI": "NIO", "NL": "EUR", "NO": "NOK", "NA": "NAD", "VU": "VUV", "NC": "XPF", "NE": "XOF", "NF": "AUD", "NG": "NGN", "NZ": "NZD", "NP": "NPR", "NR": "AUD", "NU": "NZD", "CK": "NZD", "XK": "EUR", "CI": "XOF", "CH": "CHF", "CO": "COP", "CN": "CNY", "CM": "XAF", "CL": "CLP", "CC": "AUD", "CA": "CAD", "CG": "XAF", "CF": "XAF", "CD": "CDF", "CZ": "CZK", "CY": "EUR", "CX": "AUD", "CR": "CRC", "CW": "ANG", "CV": "CVE", "CU": "CUP", "SZ": "SZL", "SY": "SYP", "SX": "ANG", "KG": "KGS", "KE": "KES", "SS": "SSP", "SR": "SRD", "KI": "AUD", "KH": "KHR", "KN": "XCD", "KM": "KMF", "ST": "STD", "SK": "EUR", "KR": "KRW", "SI": "EUR", "KP": "KPW", "KW": "KWD", "SN": "XOF", "SM": "EUR", "SL": "SLL", "SC": "SCR", "KZ": "KZT", "KY": "KYD", "SG": "SGD", "SE": "SEK", "SD": "SDG", "DO": "DOP", "DM": "XCD", "DJ": "DJF", "DK": "DKK", "VG": "USD", "DE": "EUR", "YE": "YER", "DZ": "DZD", "US": "USD", "UY": "UYU", "YT": "EUR", "UM": "USD", "LB": "LBP", "LC": "XCD", "LA": "LAK", "TV": "AUD", "TW": "TWD", "TT": "TTD", "TR": "TRY", "LK": "LKR", "LI": "CHF", "LV": "EUR", "TO": "TOP", "LT": "LTL", "LU": "EUR", "LR": "LRD", "LS": "LSL", "TH": "THB", "TF": "EUR", "TG": "XOF", "TD": "XAF", "TC": "USD", "LY": "LYD", "VA": "EUR", "VC": "XCD", "AE": "AED", "AD": "EUR", "AG": "XCD", "AF": "AFN", "AI": "XCD", "VI": "USD", "IS": "ISK", "IR": "IRR", "AM": "AMD", "AL": "ALL", "AO": "AOA", "AQ": "", "AS": "USD", "AR": "ARS", "AU": "AUD", "AT": "EUR", "AW": "AWG", "IN": "INR", "AX": "EUR", "AZ": "AZN", "IE": "EUR", "ID": "IDR", "UA": "UAH", "QA": "QAR", "MZ": "MZN"';
    var rawListCommas = rawList.split(', ');
    var fullList = [];
    rawListCommas.map(function(e) {
      var item = e.split(': ');
      var newItem = {
        countryCode: item[0].replace('"', '').replace('"', ''),
        countryCurrency: item[1].replace('"', '').replace('"', '')
      }
      fullList.push(newItem);
    });
    
    if (! firstVisitCookie) {
      $.getJSON(
        'https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572', 
        function(data) {
          var currPair = fullList.filter(e => e.countryCode == data.country_code)[0];
          
            if (currPair && (currencySelect.find('option[value="' + currPair.countryCurrency + '"]:not([selected="true"])').length > 0)) {
              Cookies.set('first_visit_cookie', '1');
              currencyInput.val(currPair.countryCurrency);
              setTimeout(function() {
                currencyForm.submit();
              }, 100);
            
          }
        }
      );
    }
  }());

  
  $(function() {
    var $faq = $('.ttComparison__faq');
    if (!$faq.length) {
      return;
    }
    
    $faq.find('h3').each(function() {
    var $title = $(this);
      var $content = $title.next('p');
      $title.click(function(e) {
        $title.toggleClass('open');
        $content.slideToggle( function(){
          // touch screens, scroll to top of clicked item
          if (e.type == 'touchend'){
            $('html, body').animate({
              scrollTop: $title.offset().top - 46
            }, 300);
          }
        });
      });
    });
  });
});

$(document).ready(function() {
  (function() {    
    function setCookie(name,value,days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    }
        
    var config = {
      langCountriesMap: {
        en: ['GB', 'US', 'CA', 'AU', 'NZ', /* 'UA' /* Remove UA !!! */],
        ko: ['KR'],
        de: [
          'DE',
          'AI',
          'LI', //Liechtenstein
          'CH' // Switzerland
        ],
        fr: [
          'FR',
          'BE', // Belgium
          'LU', // Luxembourg
          'MC', // Monaco
        ],
          ja: [
          'JP', // Japan
        ],
        he: [
          'IL' // Israel
        ],
        pt: [
          'PT', // Portugal
          'BR', // Brazil
        ],
          nl: [
          'NL', // Netherlands
        ],
        es: [
          'ES', // Spain
        ],
        zh: [
          'CN', // China
          'SG', // Singapore
           
          // 12/10/20 @mrself
          // 'TW', // Taiwan,
          
          
        ],
          
        tw: ['TW', // Taiwan,
        ],
          
        'zh-yue': [
          'HK', // Hong Kong,
          'MO', // Macau
        ]
      },

      formData: {
        en: {
          topBar: 'Free shipping and hassle-free returns worldwide',
          hello: "Hello {countryName}",
          firstParagraph: 'Sign up to our newsletter for 10% off your first <br />order and be among the first to hear about new <br />styles and exclusive promotions.',
          secondParagraph: 'Shop with us for:<br/>- Free shipping and returns to {countryName}<br />- Five year guarantee on all bags',
          changeShippingCountryBtn: "Change your shipping country",
          email: 'Your email',
          join: 'Join'
        },
        ko: {
          topBar: '전 세계 무료 배송 및 간편한 반품 시스템',
          hello: "안녕하세요",
          firstParagraph: '뉴스레터에 가입하시고 첫 주문의 10% 할인 혜택을 받으세요. 새로운 스타일과 회원 특가 소식도 제일 먼저 접하시게 됩니다.',
          secondParagraph: '주문 배송 혜택:<br/>- 한국으로 배송 및 반품 무료<br />- 모든 가방류 품질 보증 기간 5년',
          changeShippingCountryBtn: "배송 국가 변경",
          email: '귀하의 이메일',
          join: '붙다'
        },
        de: {
          topBar: 'Versandkostenfreie Lieferung und problemlose weltweite Rücksendung',
          hello: "Hallo",
          firstParagraph: 'Abonnieren Sie unseren Newsletter damit Sie als erstes über neue Designs und exklusive Verkaufsaktionen erfahren. Darüber hinaus erhalten Sie 10% Rabatt auf Ihre erste Bestellung.',
          secondParagraph: 'Bestellen Sie bei uns für:<br/>- Versandkostenfreie Lieferung und kostenlose Rücksendung<br />- 5 Jahre Garantie auf all Taschen',
          changeShippingCountryBtn: "Land ändern",
          email: 'Deine E-Mail',
          join: 'Beitreten'
        },
        fr: {
          topBar: 'Envoi et retour gratuit dans le monde entier',
          hello: "Hello",
          firstParagraph: 'Pour toute souscription à notre newsletter, bénéficiez de 10% offerts sur votre première commande et soyez les premiers à recevoir nos offres et promotions exclusives.',
          secondParagraph: 'Commandez chez Troubadour et bénéficiez<br/>- de l\'envoi et retour gratuit dans le monde entier<br />- de 5 ans de garantie sur tous nos produits',
          changeShippingCountryBtn: "Changer le pays de livraison",
          email: 'Votre email',
          join: 'Joindre'
        },
        ja: {
          topBar: '送料は無料でございます。また世界中どちらでもお手間を取らせずご返品可能です。',
          hello: "日本の皆さまこんにちは。",
          firstParagraph: 'ニュースレターに登録いただければ、初めてのオーダーにおいて10%オフとなります。',
          secondParagraph: 'また新しいスタイルや限定プロモーション情報をおしらせすることができます。<br/>送料またご返送のご料金は無料となります。<br />すべてのバッグは5年間保障となります。',
          changeShippingCountryBtn: "お届け先国の変更",
          email: 'あなたのメール',
          join: '参加する'
        },
        he: {
          topBar: 'משלוחים חינם והחזרות ללא טרחה בכל העולם',
          hello: "שלום ישראל",
          firstParagraph: 'הירשמו לידיעון שלנו וקבלו 10% הנחה על הזמנתכם הראשונה והיו בין הראשונים לדעת על המבצעים המיוחדים ועל הדגמים החדשים שלנו.',
          secondParagraph: 'קנו אצלנו וקבלו<br/>-משלוחים והחזרות חינם לישראל<br />-חמש שנות אחראיות על כל התיקים',
          changeShippingCountryBtn: "שנו את הארץ למשלוח",
          email: 'האימייל שלך',
          join: 'לְהִצְטַרֵף'
        },
        pt: {
          topBar: 'Frete grátis e fácil devolução para todo o mundo',
          hello: "Olá",
          firstParagraph: 'Assine nossa newsletter, ganhe 10% de desconto na sua primeira compra e seja o primeiro a saber das nossas novidades e promoções exclusivas.',
          secondParagraph: 'Compre conosco para:<br/>Frete e devolução grátis<br />Cinco anos de garantia em todas as bolsas',
          changeShippingCountryBtn: "Modifique o país de entrega",
          email: 'Seu email',
          join: 'Junte-se'
        },
        nl: {
          topBar: 'Gratis verzending en probleemloos terugsturen. Wereldwijd.',
          hello: "Hallo Nederland",
          firstParagraph: 'Schrijf je in op onze nieuwsbrief en ontvang 10% korting op je eerste bestelling. Ook hoor je als eerste over onze nieuwe lijnen en  speciale acties.',
          secondParagraph: 'Koop je bij ons, dan garanderen wij:<br />- gratis verzenden naar en retourneren vanuit Nederland<br />- Vijf jaar garantie op al onze tassen',
          changeShippingCountryBtn: "Kies het land van ontvangst",
          email: 'Jouw email',
          join: 'Doe mee'
        },
        es: {
          topBar: 'Envío gratis y devoluciones a nivel mundial sin ningún problema.',
          hello: "Hola España",
          firstParagraph: 'Regístrate en nuestro tablón de información si quieres tener un 10% de descuento en tu primer pedido y ser de las primeras personas en conocer nuevos estilos, promociones y ofertas exclusivas!',
          secondParagraph: 'Compra con nosotros/adquiere nuestros productos:<br />- Envío y devoluciones gratis.<br /> - Cinco años de garantía en todos nuestros productos.',
          changeShippingCountryBtn: "Kies het land van ontvangst",
          email: 'Tu correo electrónico',
          join: 'Unirse'
        },
        zh: {
          topBar: '全球免运费，退货无忧。',
          hello: "你好",
          firstParagraph: '订阅新闻通讯，首笔订单可享10%的折扣，并且您可以第一时间收到新款上市和独家促销信息。',
          secondParagraph: '在我们店购物您可尊享：<br />免费送货，免费退货<br />所有包包五年质保',
          changeShippingCountryBtn: "更换递送国家",
          email: '你的郵件',
          join: '加入'
        },
        'zh-yue': {
          topBar: '全球免運費和輕鬆簡易退貨',
          hello: "您好",
          firstParagraph: '訂閱我們的電子新聞即享有首單9折優惠，更可即時收到新款上架和推廣優惠的通知。',
          secondParagraph: '歡迎在我們網站購物<br />免運費和退貨<br />五年品質保證',
          changeShippingCountryBtn: "更改你的送貨地區",
          email: '您的電子郵件。',
          join: '加入。'
        },
        tw: {
          topBar: 'Free shipping and hassle-free returns worldwide',
          hello: 'Hello there!',
          firstParagraph: 'Sign up to our newsletter for 10% off your first order and be among the first to hear about new styles and exclusive promotions.',
          secondParagraph: 'Shop with us for:<br />- Free shipping and returns, worldwide<br />- Five year guarantee on all bags',
          changeShippingCountryBtn: "Change your shipping country",
          email: 'Your email',
          join: 'Join'
        }
      },

      countryCodesMap: {
        // UA: 'Ukraine',
        GB: 'United Kingdom',
        CA: 'Canada',
        AU: 'Australia',
        NZ: 'New Zealand',
        KR: 'South Korea',
        DE: 'Germany',
        AI: 'Austria',
        LI: 'Liechtenstein',
        CH: 'Switzerland',
        FR: 'France',
        BE: 'Belgium',
        LU: 'Luxembourg',
        MC: 'Monaco',
        JP: 'Japan',
        IL: 'Israel',
        PT: 'Portugal',
        BR: 'Brazil',
        NL: 'The Netherlands',
        ES: 'Spain',
        CN: 'China',
        SG: 'Singapore',
        TW: 'Taiwan',
        HK: 'Hong Kong',
        MO: 'Macau',
        US: 'United States',
        // US: 'United States',
      },
      
      countryCurrencyMap: {"AI": "EUR", "BE":"EUR","BL":"EUR","BV":"NOK","BQ":"USD","BR":"BRL","JE":"GBP","RU":"RUB","TL":"USD","RE":"EUR","TK":"NZD","GU":"USD","GS":"GBP","GR":"EUR","GP":"EUR","JP":"JPY","GG":"GBP","GF":"EUR","GB":"GBP","SV":"USD","HK":"HKD","HM":"AUD","PR":"USD","PS":"ILS","PW":"USD","PT":"EUR","SJ":"NOK","PH":"PHP","PN":"NZD","PM":"EUR","EE":"EUR","ZA":"ZAR","EC":"USD","IT":"EUR","VN":"VND","SA":"SAR","ES":"EUR","ME":"EUR","MF":"EUR","MC":"EUR","MH":"USD","MT":"EUR","MQ":"EUR","MP":"USD","IM":"GBP","MX":"MXN","IL":"ILS","FR":"EUR","IO":"USD","FI":"EUR","FM":"USD","NL":"EUR","NO":"NOK","NF":"AUD","NZ":"NZD","NR":"AUD","NU":"NZD","CK":"NZD","XK":"EUR","CH":"CHF","CN":"CNY","CC":"AUD","CA":"CAD","CY":"EUR","CX":"AUD","KI":"AUD","SK":"EUR","KR":"KRW","SI":"EUR","SM":"EUR","SG":"SGD","SE":"SEK","VG":"USD","DE":"EUR","US":"USD","YT":"EUR","UM":"USD","TV":"AUD","TW":"TWD","TR":"TRY","LI":"CHF","LV":"EUR","LU":"EUR","TH":"THB","TF":"EUR","TC":"USD","VA":"EUR","AE":"AED","AD":"EUR","VI":"USD","AS":"USD","AU":"AUD","AT":"EUR","IN":"INR","AX":"EUR","IE":"EUR","ID":"IDR","MO":"HKD"},
      
      
      selectOptions: {
        "AED-AE":"United Arab Emirates Dirham",
        "AUD-AU":"Australian Dollar",
        "BRL-BR":"Brazilian Real",
        "CAD-CA":"Canadian Dollar",
        "CHF-LI":"Swiss Franc (Liechtenstein)",
        "CHF-CH":"Swiss Franc (Switzerland)",
        "CNY-CN":"Chinese Renminbi Yuan",
        "EUR-DE":"Euro (Germany)",
        "EUR-AI":"Euro (Austria)",
        "EUR-FR":"Euro (France)",
        "EUR-LU":"Euro (Luxembourg)",
        "EUR-MK":"Euro (Monaco)",
        "EUR-PT":"Euro (Portugal)",
        "EUR-ES":"Euro (Spain)",
        "GBP-GB":"British Pound",
        "HKD-HK":"Hong Kong Dollar",
        "IDR-ID":"Indonesian Rupiah",
        "ILS-IL":"Israeli New Sheqel",
        "INR-IN":"Indian Rupee",
        "JPY-JP":"Japanese Yen",
        "KRW-KR":"South Korean Won",
        "MXN-MX":"Mexican Peso",
        "NOK-NO":"Norwegian Krone",
        "NZD-NZ":"New Zealand Dollar",
        "PHP-PH":"Philippine Peso",
        "RUB-RU":"Russian Ruble",
        "SAR-SA":"Saudi Riyal",
        "SEK-SE":"Swedish Krona",
        "SGD-SG":"Singapore Dollar",
        "THB-TH":"Thai Baht",
        "TRY-TR":"Turkish Lira",
        "TWD-TW":"New Taiwan Dollar",
        "USD-US":"United States Dollar",
        "VND-VN":"Vietnamese Đồng",
        "ZAR-ZA":"South African Rand"
      },
      

      getFormDataByCountryCode: function (countryCode) {
        var langCode = this.getLangCodeByCountryCode(countryCode);
        return this.formData[langCode];
      },

      getLangCodeByCountryCode: function (countryCode) {
        for (var langCode in this.langCountriesMap) {
          var countryCodes = this.langCountriesMap[langCode];

          if (countryCodes.indexOf(countryCode) !== -1) {
            return langCode;
          }
        }

        return null;
      },
    }

    var Geolocation = {
      url: 'https://api.ipstack.com/check?access_key=' + API_KEY,

      fetch: function () {
        if (getCookie('klaviyo_country_code')) {
          return $.when({
            country_code: getCookie('klaviyo_country_code')
          });
        }
        
        if (this.promise) {
          return this.promise;
        }

        return this.promise = $.getJSON(this.url).then(function(data) {
          Logger.log('Geo location data fetched:');
          Logger.log(data);
          Logger.log('');
          
          setCookie('klaviyo_country_code', data.country_code, 100);
          
          return data;
        });
      }
    };

    var topBar = {
      init() {
        let cookieCountryCode = getCookie('klaviyo_country_code');
       // alert(formData1);
        if (cookieCountryCode) {
          var formData1 = config.getFormDataByCountryCode(cookieCountryCode);
          if (formData1) {
            $('.headerAnnouncement').text(formData1.topBar);
          }
        } else {
          console.log('Geolocation has been fired: topBar.init()');
          Geolocation.fetch().then(function (geolocationData) {
            console.log(geolocationData);
            var formData = config.getFormDataByCountryCode(geolocationData.country_code);
            if (!formData) {
              return;
            }
            $('.headerAnnouncement').text(formData.topBar);
          });          
        }
      }
    };
    
    var Logger = {
      log: function(message) {
        if (true) {
          console.log(message);
        }
      }
    };

    var SignUp = {
      boot: function () {
        var self = this;
        this.flag = setInterval(function () {
          self.checkInit();
        }, 450);
      },

      checkInit: function () {
        this.$klaviyoPopup = $('.klaviyo-form[formtype="POPUP"]');
        if (this.$klaviyoPopup.length) {
          clearInterval(this.flag);
          this.init();
        }
      },

      init: function () {
        var self = this;
        if (getCookie('klaviyo_country_code')) {
          self.initCustomForm(getCookie('klaviyo_country_code'));
          self.showKlaviyoPopup();
        } else {
          console.log('Geolocation has been fired: SignUp.init()');
          Geolocation.fetch().then(function (data) {
            self.initCustomForm(data.country_code);
            self.showKlaviyoPopup();
          });
        }
      },

      initCustomForm: function (countryCode) {
        // 10/20/20
        this.saveCountryCode(countryCode);
        
        var formData = config.getFormDataByCountryCode(countryCode);
        if (!formData) {
          Logger.log('No translation found');
          return;
        }
        
        this.insertCustomSubmitBtn();
        this.translateByCountryCode(countryCode);
        this.initChangeCountry();
        
        this.getCustomContainer().append('<p class="klaviyoAlert">We use cookies to optimise your site experience. Learn more <a href="/pages/cookies">here</a>.</p>');
      },
      
      insertCustomSubmitBtn: function() {
        var $originalBtn = this.getKlaviyoSubmitBtn();
        $originalBtn.parent().hide();
        this.$customSubmitBtn = $(Renderer.customSubmitBtn())
          .appendTo(this.getCustomContainer())
          .click(function() {
			      $originalBtn.click();
          });
      },
      
      getKlaviyoSubmitBtn: function() {
        return this.$klaviyoPopup
        	.find('form')
        	.find('[type=button]')
        	.first();
      },
      
      showKlaviyoPopup: function() {
        this.$klaviyoPopup.addClass('klaviyo-form-visible');
      },

      configureRenderer: function (countryCode) {
        var formData = config.getFormDataByCountryCode(countryCode);
        Renderer.init(formData, countryCode);
      },

      updateCustomContent: function () {
        this.$klaviyoPopup
        .find('.ql-container')
        .empty()
        .append(this.makeCustomContent());
      },

      initChangeCountry: function () {
        this.getCustomContainer()
        // .append(Renderer.changeCountryBtn())
        .append(Renderer.countriesDropdown());
        // this.$klaviyoPopup.find('select').val(Renderer.countryCode);
        this.initSelect();
        var self = this;
        this.$klaviyoPopup.on('click', '.klavioBtn', function() {
          self.$klaviyoPopup.find('.selectric-wrapper').show()
        });
      },
      
      getCustomContainer: function() {
        return this.$klaviyoPopup.find('form')
          .find('> div')
          .first();
      },

      updateKlaviyoForm: function (formData) {
        this.$klaviyoPopup.find('[name=email]').attr('placeholder', formData.email.toUpperCase());
        this.$customSubmitBtn.text(formData.join.toUpperCase());
      },
      
      findKlaviyoSubmitBtn() {
        return this.$klaviyoPopup
        	.find('form')
        	.find('[type=button]')
        	.first();
      },

      initSelect: function () {
        var self = this;
        var $select = this.$klaviyoPopup.find('select');
        $select.selectric();
        $select.first().change(function () {
          Logger.log('Click on "Change shipping country"');
          if ($select.val() === '0') {
            return;
          }
          
          var countryCode = $select.val();
          self.saveCountryCode(countryCode);
          self.changeCurrency(config.countryCurrencyMap[countryCode]);
          
          if (config.countryCodesMap[countryCode]) {
            self.translateByCountryCode(countryCode);
          }
          
          // var parts = $select.val().split('-');
          // self.saveCountryCode(parts[1]);
          // self.changeCurrency(parts[0]);
          // if (config.countryCodesMap[parts[1]]) {
          //   self.translateByCountryCode(parts[1]);
          // }
          
          // $select.closest('.selectric-wrapper').hide(); 
        });
      },
      
      saveCountryCode(code) {
        // 10/20/20
        setCookie('klaviyo_country_code', code, 100);
        return;
        
        if (config.countryCodesMap[code]) {
          setCookie('klaviyo_country_code', code, 100);
        } else {
          setCookie('klaviyo_country_code', '', 100);
        }
        
      },
      
      changeCurrency(currencyCode) {
        // @mrself 1/26/21
        Cookies.set('first_visit_cookie', '1');
        
        $('#currentCurrencyInp').val(currencyCode);
        setTimeout(function() {
          $('#localization_form').submit();
        }, 100);
      },

      translateByCountryCode: function (countryCode) {
        var formData = config.getFormDataByCountryCode(countryCode);
        Logger.log('Translation found:');
        Logger.log(formData);
        Logger.log('');
        this.configureRenderer(countryCode);
        this.updateCustomContent();
        this.updateKlaviyoForm(formData);
      },

      makeCustomContent: function () {
        return $('<div />', {'class': 'klaviyoForm'})
        .append(Renderer.h2())
        .append(Renderer.firstParagraph())
        .append((Renderer.secondParagraph()))
      },
    };

    var Renderer = {
      init: function (formData, countryCode) {
        this.formData = formData;
        this.countryCode = countryCode;
        this.countryName = config.countryCodesMap[countryCode];
      },
      
      customSubmitBtn: function() {
        return '<button class="cklSubmitBtn" type="button"></button>';
      },

      h2: function () {
        var mark = '';
        var countriesWithMark = ['DE', 'AI', 'LI', 'CH', 'FR', 'BE', 'LU', 'MC', 'CN', 'SG', 'HK', 'MO'];
        if (countriesWithMark.indexOf(this.countryCode) !== -1) {
			    mark = '!'
        }
        
        return '<h2>' + this.renderHello() + this.renderImg() + ' ' + mark + '</h2>';
      },

      firstParagraph() {
        return '<p>' + this.formData.firstParagraph + '</p>';
      },

      secondParagraph() {
        return '<p>' + this.formData.secondParagraph
        .replace('{countryName}', this.countryName) + '</p>';
      },

      renderHello: function () {
        return this.formData.hello
        .replace('{countryName}', this.countryName);
      },

      changeCountryBtn: function () {
        return '<button class="klavioBtn" type="button">' 
        + this.formData.changeShippingCountryBtn 
        + '</button>';
      },

      countriesDropdown: function () {
        //var dropdown = '<select><option value="0">CHANGE YOUR SHIPPING COUNTRY</option>';
        var dropdown = '<select><option value="0">' + this.formData.changeShippingCountryBtn.toUpperCase() +  '</option>';
        
        var selectOptions = this.sortSelectOptions();
        // for (var code in selectOptions) {
        //   var name = selectOptions[code];
        //   dropdown += '<option value="' + code + '">' + name + '</option>';
        for (var name in selectOptions) {
          var value = selectOptions[name];
          // if (value == 'US') {
          //   dropdown += '<option value="' + value + '">' + name + '</option>';
          //   dropdown += '<option value="Global">Global (in USD)</option>';
          // } else {
          //   dropdown += '<option value="' + value + '">' + name + '</option>';
          // }
          dropdown += '<option value="' + value + '">' + name + '</option>';
        }
        return dropdown + '</select>';
      },
      
      sortSelectOptions: function() {
        var res = {};
        for (var k in config.countryCodesMap) {
          res[config.countryCodesMap[k]] = k;
        }
        
        return Object.keys(res)
          .sort()
          .reduce(function(result, key) {
			      result[key] = res[key];
          	return result;
        	}, {});
        
      },

      renderImg: function () {
        if (this.countryCode === 'TW') {
          return '';
        }
       
        // return '<strong class="currency-flag currency-flag-' + currency.toLowerCase() + '"></strong>';
        var countryCode = this.countryCode.toLowerCase();
        return '<img src="https://assets.ipstack.com/flags/' + countryCode + '.svg">';
      },
    }
    
    try {
      topBar.init();
      SignUp.boot();
    } catch (e) {
      console.error(e);
    }

  })();
});

$(document).ready(function() {
  
  function fixCartBtn() {
    var addToCart = $('#add-to-bag');
    var addToCartSticky = $('.addtocart-sticky');
    var scroll = $(window).scrollTop();
    if (addToCart.length) {
      if (scroll > addToCart.offset().top) {
        addToCartSticky.addClass('mod-visible');
      } else {
        addToCartSticky.removeClass('mod-visible');
      }
    }
  }

  $(window).scroll(function() {    
    fixCartBtn();
  });
  fixCartBtn();

  // Change the way Yotpo reviews count are rendered on product items
  if ($('.yotpoCustomStars .yotpo').length) {
    var target = $('.yotpoCustomStars .yotpo')[0];
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function( mutation ) {
        var newNodes = mutation.addedNodes;
        if ( newNodes !== null ) {
          $('.yotpoCustomStars').each(function() {
            var $self = $(this);
            
            var $text = $self.find('.yotpo-bottomline .text-m');
            var reviewsCount = $text.text().trim().split(' ')[0];
            $text.text(reviewsCount);
          });
        }
      });    
    });
  
    var config = { 
      attributes: true, 
      childList: true, 
      characterData: true 
    };
    observer.observe(target, config);
  }

  //adding + - to qty text field
  $('.qtybox .btnqty').on('click', function() {
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if ($(this).hasClass('qtyplus')) {
      qty++;
    } else {
      if (qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
  });
  
  if ($('.yotpo-reviews .yotpo-main-widget').length) {
    var target = $('.yotpo-reviews .yotpo-main-widget')[0];
    var targetParent = $('.yotpo-reviews');
    var revSecObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function( mutation ) {
        var newNodes = mutation.addedNodes;
        if ( newNodes !== null ) {
          targetParent.removeClass('d-none');
        }
      });    
    });
    
    var config = { 
      attributes: true, 
      childList: true, 
      characterData: true 
    };
    revSecObserver.observe(target, config);
  }
  
  $('.ourStoreHeroArrow').on('click', function() {
    let headerHeight = $('.siteHeader').height();
    let headerTopHeight = $('.siteHeaderTop').height();
    let windowHeight = $(window).height();
    $('html, body').animate({ scrollTop: (windowHeight * 3 - (headerHeight - headerTopHeight)) }, 1000);
  });

  $(function() {
    function animateElOpacity() {
      var indicatorHeight = $(window).height();
      var animateOpacityWrapper = $('.animateOpacityWrapper');
      var animateOpacityTop = $('.animateOpacityTop');
      var animateOpacityBottom = $('.animateOpacityBottom');
      var target = $('.animateOpacity');
      var targetHeight = target.outerHeight() / 1;
      var scrollPercent = (targetHeight - window.scrollY) / targetHeight;
      if (scrollPercent >= 0) {
        target.css('opacity', scrollPercent);
      }
      if (window.scrollY > indicatorHeight) {
        target.css('opacity', scrollPercent);
      }
      if (window.scrollY > (indicatorHeight * 2)) {
        animateOpacityBottom.removeClass('locked');
        animateOpacityWrapper.addClass('scrolled');
      } else {
        animateOpacityBottom.addClass('locked');
        animateOpacityWrapper.removeClass('scrolled');
      }
    }
    if ($('body').hasClass('page.our-store')) {
      animateElOpacity();
      $(document).scroll(function(e) {
        animateElOpacity();
      });
    }
  });
  
  
//   FAQ accordian script
  
   $(".faq_set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".faq_set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".faq_set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".faq_set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });
  
//   tab script
  // Show the first tab by default
  $('.sust_ctm .tabs-stage div.tab_ctm').hide();
  $('.sust_ctm .tabs-stage div.tab_ctm:first').show();
  $('.sust_ctm .tabs-nav li:first').addClass('tab-active');

  // Change tab class and display content
  $('.sust_ctm .tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.sust_ctm .tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.sust_ctm .tabs-stage div.tab_ctm').hide();
    $($(this).attr('href')).show();
  });
  
});

$(function() {

    $('.faq_set').on('click', function() {
      $(this).siblings().removeClass('faq-active')
      $(this).addClass('faq-active');
    });

});

$(document).ready(function() {
 
   
  $( ".tab_one_button1" ).on( "click", function() {
   
    $('.tab_color2 a').trigger( "click" );
    setTimeout(function(){
    	$("html, body").animate({ scrollTop: 0 }, 100);
    }, 100);
    
  });
  
  

  
  $( ".tab_two_button1" ).on( "click", function() {
    $('.tab_color3 a').trigger( "click" );
    setTimeout(function(){
    	$("html, body").animate({ scrollTop: 0 }, 100);
    }, 100);
  });
   
});

// $(document).ready(function() {
      
//       if($('.the-swatches .selected').hasClass('soldout')) {
//       	$('#klaviyoPlacement').removeClass('hidden');
//       } else {
//       	$('#add-to-bag').removeClass('hidden');
//       }
  

  
//     });
//     $('body').on('click','.the-swatches > span',function(){
//       if($(this).hasClass('soldout')) {
//       	$('#klaviyoPlacement').removeClass('hidden');
//         $('#add-to-bag').addClass('hidden');
//       } else {
//       	$('#klaviyoPlacement').addClass('hidden');
//         $('#add-to-bag').removeClass('hidden');
//       }
//     });

$(document).ready(function() {
      if($('.the-swatches .selected').hasClass('soldout')) {
      	$('#soldout').removeClass('hidden');
      } else {
      	$('#add-to-bag').removeClass('hidden');
      }
    });
    
    $('body').on('click','.the-swatches > span',function(){
      if($(this).hasClass('soldout')) {
      	$('#soldout').removeClass('hidden');
        $('#add-to-bag').addClass('hidden');
      } else {
      	$('#soldout').addClass('hidden');
        $('#add-to-bag').removeClass('hidden');
      }
    });




$(document).ready(function() {
  $(".coll-page--filters-links a").click(function () {
    if( $(".coll-page--filters-links a").hasClass('menu-inner') ){
    $(".coll-page--filters-links a").removeClass("menu-inner")
    }
    else{
    $(this).toggleClass("menu-inner")
    } 
   // $(".coll-page--filters-links-inner").removeClass("slide")
      if( $(".coll-page--filters-links-inner").hasClass('slide') ){
        $(".coll-page--filters-links-inner").removeClass("slide")
      }
    else{
      $(this).siblings(".coll-page--filters-links-inner").toggleClass("slide");
    }
  });
});

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// $(document).ready(function() { 
//   setTimeout(function() { 
// var currency = getCookie('cart_currency');
//   //alert(currency);
//   if(currency =='USD'){
//    $('.headerAnnouncement').text("FREE SHIPPING OVER $75 AND HASSLE-FREE RETURNS");
//  }
//   else if(currency =='GBP'){
//    $('.headerAnnouncement').text("FREE SHIPPING OVER £50 AND HASSLE-FREE RETURNS"); 
//  }
//   else if(currency =='EUR'){
//   $('.headerAnnouncement').text("FREE SHIPPING OVER €50 AND HASSLE-FREE RETURNS"); 
//  }
//   else{
//    $('.headerAnnouncement').text("EXPRESS SHIPPING AND HASSLE-FREE RETURNS"); 
//  }

//   }, 2000);	 
// });


/* Start Window load issue 
  $(document).ready(function(){
    setTimeout(function(){
  if (window.location.href == 'https://www.mujjo.com/' ) {
    window.stop();
    }
      }, 2000);
  });
 End Window load issue */


// zindex issue in sub popup
 $(document).ready(function(){
   $('.header-subscribebtn').addClass('d-none');
   $( ".site-header--bar-icons button.subscribe_btn" ).click(function() {
     $('.header-subscribebtn').toggleClass('d-none');
    });
  });

  /* Announcement Message */
$(document).ready(function() { 
  setInterval(function() { 
var currency = getCookie('cart_currency');
    var localization = getCookie('localization');
  if(currency =='USD'){
   $('.headerAnnouncement').text($('.headerAnnouncementjs .spanheaderAnnouncement-US').html());
 }
  else if(currency =='GBP' && localization == 'GB'){
   $('.headerAnnouncement').text($('.headerAnnouncementjs .spanheaderAnnouncement-UK').html()); 
 }
  else if(currency =='EUR' && localization == 'DE' ){
   $('.headerAnnouncement').text($('.headerAnnouncementjs .spanheaderAnnouncement-German').html()); 
 }
  else{
   $('.headerAnnouncement').text($('.headerAnnouncementjs .spanheaderAnnouncement-OTHER').html()); 
 }

  }, 500);     
});



/* Country Flag Change */ 

   var countryImages = {
    "US": "https://cdn.shopify.com/s/files/1/0171/0160/files/1200px-Flag_of_the_United_States.svg-_1.jpg?v=1670322645",
    "GB": "https://cdn.shopify.com/s/files/1/0171/0160/files/UK-flag.jpg?v=1670324343",
    "CA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Flag_of_Canada__Pantone.png?v=1676463573",
    "AD": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Andorra.jpg?v=1676465672",
    "AE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ae.png?v=1676465814",
    "AF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Afghanistan.jpg?v=1676465923",
    "AG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Antigua_and_Barbuda.jpg?v=1676465961",
    "AI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Antigua_and_Barbuda.jpg?v=1676465961",
    "AL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/al.png?v=1676533651",
    "AM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Armenia.jpg?v=1676466123",
    "AO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ao.png?v=1676466204",
    "AQ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/aq.png?v=1676466314",
    "AR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Argentina.jpg?v=1676466343",
    "AS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/as.png?v=1676466442",
    "AT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Austria.jpg?v=1676466469",
    "AU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Australia.jpg?v=1676466497",
    "AW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/aw.png?v=1676466644",
    "AX": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ax.png?v=1676466763",
    "AZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/az.png?v=1676466813",
    "BA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Bosnia_and_Herzegovina.jpg?v=1676466871",
    "BB": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Barbados.jpg?v=1676466931",
    "BD": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Bangladesh.jpg?v=1676466968",
    "BE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Belgium.jpg?v=1676467039",
    "BF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bf.png?v=1676467190",
    "BG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Bulgaria.jpg?v=1676467561",
    "BH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Bahrain.jpg?v=1676467598",
    "BI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bi.png?v=1676467670",
    "BJ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bj.png?v=1676467972",
    "BL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bl.png?v=1676467972",
    "BM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bm.png?v=1676467972",
    "BN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bn.png?v=1676467972",
    "BO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bo.png?v=1676467972",
    "BQ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bq.png?v=1676467972",
    "BR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/br.png?v=1676467972",
    "BS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bs.png?v=1676468060",
    "BT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/Bhutan.jpg?v=1676525647",
    "BV": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bv.png?v=1676525749",
    "BW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bw.png?v=1676526635",
    "BY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/by.png?v=1676526635",
    "BZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/bz.png?v=1676526635",
    "CA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ca.png?v=1676526635",
    "CC": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cc.png?v=1676526635",
    "CD": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cd.png?v=1676526635",
    "CF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cf.png?v=1676526634",
    "CG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cg.png?v=1676526635",
    "CH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ch.png?v=1676526636",
    "CI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ci.png?v=1676526636",
    "CK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ck.png?v=1676526636",
    "CL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cl.png?v=1676526635",
    "CM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cm.png?v=1676526635",
    "CN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cn.png?v=1676526635",
    "CO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/co.png?v=1676526635",
    "CR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cr.png?v=1676526635",
    "CU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cu.png?v=1676526635",
    "CV": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cv.png?v=1676526635",
    "CW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cw.png?v=1676526635",
    "CX": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cx.png?v=1676526635",
    "CY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cy.png?v=1676526635",
    "CZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/cz.png?v=1676526635",
    "DE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/de.png?v=1676526635",
    "DJ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/dj.png?v=1676526635",
    "DK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/dk.png?v=1676529251",
    "DM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/dm.png?v=1676529251",
    "DO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/do.png?v=1676529251",
    "DZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/dz.png?v=1676529251",
    "EC": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ec.png?v=1676529251",
    "EE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ee.png?v=1676529251",
    "EG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/eg.png?v=1676529251",
    "EH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/eh.png?v=1676529252",
    "ER": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/er.png?v=1676529251",
    "ES": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/es.png?v=1676529251",
    "ET": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/et.png?v=1676529251",
    "FI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/fi.png?v=1676529251",
    "FJ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/fj.png?v=1676529251",
    "FK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/fk.png?v=1676529251",
    "FM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/fm.png?v=1676529251",
    "FO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/fo.png?v=1676529251",
    "FR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/fr.png?v=1676529250",
    "GA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ga.png?v=1676529251",
    "GB": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gb.png?v=1676529250",
    "GD": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gd.png?v=1676529251",
    "GE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ge.png?v=1676529251",
    "GF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gf.png?v=1676529251",
    "GG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gg.png?v=1676529251",
    "GH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gh.png?v=1676529251",
    "GI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gi.png?v=1676529251",
    "GL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gl.png?v=1676529251",
    "GM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gm.png?v=1676529250",
    "GN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gn.png?v=1676529250",
    "GP": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gp.png?v=1676529250",
    "GQ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gq.png?v=1676529250",
    "GR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gr.png?v=1676529250",
    "GS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gs.png?v=1676529250",
    "GT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gt.png?v=1676529251",
    "GU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gu.png?v=1676529250",
    "GW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gw.png?v=1676529250",
    "GY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/gy.png?v=1676529250",
    "HK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/hk.png?v=1676529250",
    "HM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/hm.png?v=1676529250",
    "HN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/hn.png?v=1676529251",
    "HR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/hr.png?v=1676529250",
    "HT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ht.png?v=1676529250",
    "HU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/hu.png?v=1676529250",
    "ID": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/id.png?v=1676529250",
    "IE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ie.png?v=1676529250",
    "IL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/il.png?v=1676529250",
    "IM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/im.png?v=1676529250",
    "IN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/in.png?v=1676529250",
    "IO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/io.png?v=1676529251",
    "IQ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/iq.png?v=1676529251",
    "IR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ir.png?v=1676529251",
    "IS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/is.png?v=1676529251",
    "IT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/it.png?v=1676529251",
    "JE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/je.png?v=1676529251",
    "JM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/jm.png?v=1676529251",
    "JO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/jo.png?v=1676529250",
    "JP": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/jp.png?v=1676529250",
    "KE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ke.png?v=1676529250",
    "KG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/kg.png?v=1676529250",
    "KH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/kh.png?v=1676529249",
    "KI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ki.png?v=1676529248",
    "KM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/km.png?v=1676529248",
    "KN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/kn.png?v=1676529248",
    "KP": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/kp.png?v=1676529248",
    "KR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/kr.png?v=1676529248",
    "KW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/kw.png?v=1676529248",
    "KY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ky.png?v=1676529248",
    "KZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/kz.png?v=1676529247",
    "LA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/la.png?v=1676529248",
    "LB": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/lb.png?v=1676529247",
    "LC": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/lc.png?v=1676529247",
    "LI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/li.png?v=1676529248",
    "LK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/lk.png?v=1676529247",
    "LR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/lr.png?v=1676529247",
    "LS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ls.png?v=1676529247",
    "LT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/lt.png?v=1676529247",
    "LU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/lu.png?v=1676529249",
    "LV": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/lv.png?v=1676529249",
    "LY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ly.png?v=1676529250",
    "MA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ma.png?v=1676529249",
    "MC": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mc.png?v=1676529249",
    "MD": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/md.png?v=1676529249",
    "ME": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/me.png?v=1676529249",
    "MF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mf.png?v=1676529249",
    "MG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mg.png?v=1676529249",
    "MH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mh.png?v=1676529250",
    "MK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mk.png?v=1676529249",
    "ML": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ml.png?v=1676529249",
    "MM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mm.png?v=1676529249",
    "MN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mn.png?v=1676529249",
    "MO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mo.png?v=1676529249",
    "MP": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mp.png?v=1676529247",
    "MQ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mq.png?v=1676529247",
    "MR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mr.png?v=1676529247",
    "MS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ms.png?v=1676529247",
    "MT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mt.png?v=1676529247",
    "MU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mu.png?v=1676529247",
    "MV": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mv.png?v=1676529247",
    "MW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mw.png?v=1676529247",
    "MX": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mx.png?v=1676529247",
    "MY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/my.png?v=1676529247",
    "MZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/mz.png?v=1676529247",
    "NA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/na.png?v=1676532038",
    "NC": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/nc.png?v=1676532039",
    "NE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ne.png?v=1676532039",
    "NF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/nf.png?v=1676532039",
    "NG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ng.png?v=1676532039",
    "NI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ni.png?v=1676532038",
    "NL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/nl.png?v=1676532038",
    "NO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/no.png?v=1676532038",
    "NP": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/np.png?v=1676532038",
    "NR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/nr.png?v=1676532038",
    "NU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/nu.png?v=1676532038",
    "NZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/nz.png?v=1676532038",
    "OM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/om.png?v=1676532038",
    "PA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pa.png?v=1676532038",
    "PE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pe.png?v=1676532038",
    "PF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pf.png?v=1676532038",
    "PG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pg.png?v=1676532038",
    "PH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ph.png?v=1676532038",
    "PK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pk.png?v=1676532038",
    "PL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pl.png?v=1676532038",
    "PM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pm.png?v=1676532038",
    "PN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pn.png?v=1676532038",
    "PR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pr.png?v=1676532038",
    "PS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ps.png?v=1676532037",
    "PT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pt.png?v=1676532037",
    "PW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/pw.png?v=1676532037",
    "PY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/py.png?v=1676532037",
    "QA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/qa.png?v=1676532037",
    "RE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/re.png?v=1676532037",
    "RO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ro.png?v=1676532037",
    "RS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/rs.png?v=1676532037",
    "RU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ru.png?v=1676532037",
    "RW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/rw.png?v=1676532037",
    "SA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sa.png?v=1676532037",
    "SB": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sb.png?v=1676532037",
    "SC": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sc.png?v=1676532037",
    "SD": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sd.png?v=1676532037",
    "SE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/se.png?v=1676532037",
    "SG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sg.png?v=1676532036",
    "SH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sh.png?v=1676532037",
    "SI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/si.png?v=1676532036",
    "SJ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sj.png?v=1676532036",
    "SK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sk.png?v=1676532036",
    "SL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sl.png?v=1676532036",
    "SM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sm.png?v=1676532036",
    "SN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sn.png?v=1676532036",
    "SO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/so.png?v=1676532036",
    "SR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sr.png?v=1676532036",
    "SS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ss.png?v=1676532036",
    "ST": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/st.png?v=1676532035",
    "SV": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sv.png?v=1676532035",
    "SX": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sx.png?v=1676532035",
    "SY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sy.png?v=1676532035",
    "SZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/sz.png?v=1676532035",
    "TC": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tc.png?v=1676532034",
    "TD": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/td.png?v=1676532035",
    "TF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tf.png?v=1676532035",
    "TG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tg.png?v=1676532034",
    "TH": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/th.png?v=1676532034",
    "TJ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tj.png?v=1676532034",
    "TK": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tk.png?v=1676532035",
    "TL": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tl.png?v=1676532034",
    "TM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tm.png?v=1676532034",
    "TN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tn.png?v=1676532034",
    "TO": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/to.png?v=1676532034",
    "TR": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tr.png?v=1676532036",
    "TT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tt.png?v=1676532035",
    "TV": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tv.png?v=1676532035",
    "TW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tw.png?v=1676532035",
    "TZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/tz.png?v=1676532035",
    "UA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ua.png?v=1676532035",
    "UG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ug.png?v=1676532035",
    "UM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/um.png?v=1676532035",
    "US": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/us.png?v=1676532034",
    "UY": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/uy.png?v=1676532034",
    "UZ": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/uz.png?v=1676532034",
    "VA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/va.png?v=1676532034",
    "VC": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/vc.png?v=1676532034",
    "VE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ve.png?v=1676532034",
    "VG": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/vg.png?v=1676532034",
    "VI": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/vi.png?v=1676532033",
    "VN": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/vn.png?v=1676532033",
    "VU": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/vu.png?v=1676532033",
    "WF": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/wf.png?v=1676532033",
    "WS": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ws.png?v=1676532033",
    "YE": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/ye.png?v=1676532033",
    "YT": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/yt.png?v=1676532033",
    "ZA": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/za.png?v=1676532033",
    "ZM": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/zm.png?v=1676532033",
    "ZW": "https://cdn.shopify.com/s/files/1/0647/1067/2632/files/zw.png?v=1676532032"
  }
  $(document).ready(function() {
   setTimeout(function() { 
  var selectedCountry = window.localStorage.getItem("sel-autodetect-country");
  if (!selectedCountry) {
    try {
      $.getJSON("http://ipinfo.io?token=b02da93fe981b7", function (e) {
          $(".country_flag img").attr("src", countryImages[e.country]);

      });
    } catch (error) {
       $(".country_flag img").attr("src", countryImages['US']);
    }
  } else {
    $(".country_flag img").attr("src", countryImages[selectedCountry])
  }
  }, 500); 
  });



// variant's metafield value script

window.onload = function (e) {
  setTimeout(function () {
    var selectedCountry = window.localStorage.getItem("sel-autodetect-country");
    var current_URL = window.location.href;

    if (current_URL.indexOf("/products/") !== -1) {
      $('.swatch').click(function () {
        const Varid = $(this).data('variant-id');
        variantregion(Varid); 
      });

      if ($('.the-swatches .available').hasClass('selected')) {
        variantregion(); 
      }
      
      var element = document.querySelector('.the-swatches .available.selected');
      if (element) {
        var spanElement = element.querySelector('span');
        var variantId = spanElement.getAttribute('data-variant-id');
        variantregion(variantId);
      }


      function variantregion(Varid) {
        console.log('Varidmujjo',Varid);
        const scriptElement = document.querySelector('script[id="variant_metadata"]');
        if (scriptElement) {
          try {
            const jsonContent = scriptElement.textContent.trim();
            const jsonData = JSON.parse(jsonContent);
            for (const item of jsonData) {
              const comingSoonValue = item.comingsoon;
              const RegVariantId = item.id;

              if (Varid == RegVariantId) {
                if (comingSoonValue.includes("Coming-soon_")) {
                  
                  const parts = comingSoonValue.split("_");
                  const countryCode = parts[parts.length - 1];
      
                  if (selectedCountry == countryCode) {
                    $('input#add-to-bag').attr('value', 'Coming Soon');
                    $('input#add-to-bag').attr('disabled', 'disabled');
                  } else {
                    $('input#add-to-bag').attr('value', 'Add to cart');
                    $('input#add-to-bag').removeAttr('disabled', 'disabled');
                  }
                } else {
                  $('input#add-to-bag').attr('value', 'Add to cart');
                  $('input#add-to-bag').removeAttr('disabled', 'disabled');
                }
              }
            }
          } catch (error) {
            console.error("Error parsing JSON:", error);
          }
        } else {
          console.error("Script element not found");
        }
      }
    }
  }, 400);
}

// on time change cart's values
$(document).ready(function () {
  $('.qtyplus').off('click').on('click', function (event) {
    event.preventDefault();
    let quantityInput = $(this).siblings('.quantity-input');
    let currentValue = parseInt(quantityInput.val());

    if (!isNaN(currentValue)) {
      quantityInput.val(currentValue + 1);
      console.log('plus: ', quantityInput.val()); // Debugging line to track value
      updateCart(quantityInput);
    }
  });

  $('.qtyminus').off('click').on('click', function (event) {
    event.preventDefault();
    let quantityInput = $(this).siblings('.quantity-input');
    let currentValue = parseInt(quantityInput.val());

    if (!isNaN(currentValue) && currentValue > 1) {
      quantityInput.val(currentValue - 1);
      console.log('minus: ', quantityInput.val()); // Debugging line to track value
      updateCart(quantityInput);
    }
  });

  function updateCart(quantityInput) {
    // Trigger the actual cart update logic here
    $('#update_quantities').click();
  }
});


// cart drawer
// $(document).ready(function() {
//   var currentValue = undefined
//   $('.qty-info .qtyplus').unbind('click').click(function() {
//     currentValue = parseInt($('.qty-info .quantity-input').val());
//     $('.qty-info .quantity-input').attr('value',currentValue + 1);
//     $('.cart-info .quantity-selector').attr('value',currentValue);
//   });

//   $('.qty-info .qtyminus').unbind('click').click(function() {
//     var currentValue = parseInt($('.qty-info .quantity-input').val());
//     $('.qty-info .quantity-input').attr('value',Math.max(currentValue - 1, 1));
//     console.log('cartdr minus');
//   });

//   $('.cart_drawer_btn').click(function() {
//     console.log(currentValue)
//     var drawer_cart = $('.qty-info .quantity-input').val();
//       $('.cart-info .quantity-selector').attr('value',currentValue);
//       $('#update_quantities').click();
//   });
// });

// Search filter | TS

$(document).ready(function () {
    var faqSwiper = new Swiper(".faq_slider", {
      direction: "horizontal",
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets", // Change 'progressbar' to 'bullets'
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      mousewheel: false,
      keyboard: false,
    });

    var recommendedSwiper = new Swiper(".recommend_product", {
      direction: "horizontal",
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets", // Change 'progressbar' to 'bullets'
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      mousewheel: false,
      keyboard: false,
    });
  
var clearIcon = $(".clear-icon");
var searchBar = $("#collection_search_bar");

var prodDisp = $(".prod__disp");
var paginateProducts = $(".paginate_products");
var faqsSection = $(".faqs_section");

clearIcon.click(function () {
    searchBar.val("");
    searchBar.change();
    clearIcon.addClass("hidden");
    paginateProducts.show();
    prodDisp.addClass("hidden");
});
  function checkInput() {
    if (searchBar.val().length) {
      clearIcon.removeClass("hidden");
      prodDisp.removeClass("hidden");
      paginateProducts.hide();
      
    } else {
      clearIcon.addClass("hidden");
      paginateProducts.show();
      prodDisp.addClass("hidden");
    }
  }

  $(document).on("input change","#collection_search_bar", function () {
    var searchTerm = $(this).val();
    $("#search_input").text(searchTerm);
    checkInput();
    performSearch(searchTerm);
    faqSearch(searchTerm);
    resultsFound();
  });

  function performSearch(termToSearch) {
    var prodDisp = $(".prod__disp");
    prodDisp.find(".all_products .panel_ctm").each(function () {
      var panelContainer = $(this);
      var panelContainerId = "#" + panelContainer.attr("id");
      var termToSearchLower = termToSearch.toLowerCase();

      $.extend($.expr[":"], {
        contains: function (elem, i, match, array) {
          return (
            (elem.textContent || elem.innerText || "")
              .toLowerCase()
              .indexOf((match[3] || "").toLowerCase()) >= 0
          );
        },
      });

      var matchingPanels = $(
        panelContainerId + ":contains(" + termToSearch + ")"
      );
      var nonMatchingPanels = $(
        panelContainerId + ":not(:contains(" + termToSearch + "))"
      );

      nonMatchingPanels.hide().addClass("ctm-shop-hidden");
      matchingPanels.show().removeClass("ctm-shop-hidden");

      var hiddenPanelsCount = prodDisp.find(
        ".all_products .panel_ctm.ctm-shop-hidden"
      ).length;

      if (hiddenPanelsCount <= 0) {
        $(".products_heading").addClass("hidden");
      } else {
        $(".products_heading").removeClass("hidden");
      }
    });
  }

  function faqSearch(searchFaq) {
    var faqSlider = $(
      ".prod__disp .swiper.faq_slider.collection_post .swiper-slide.panel_ctm"
    );

    faqSlider.each(function () {
      var panelContainerId = $(this);
      var faqQuestion = panelContainerId.find(".faq_que").text().toLowerCase();

      if (faqQuestion.includes(searchFaq.toLowerCase())) {
        panelContainerId.show().removeClass("ctm-shop-hidden");
      } else {
        panelContainerId.hide().addClass("ctm-shop-hidden");
      }
    });

    var hiddenFaqCount = faqSlider.filter(".ctm-shop-hidden").length;


    if (hiddenFaqCount <= 0) {
      $(".faqs_sectionTitle").addClass("hidden");
    } else {
      $(".faqs_sectionTitle").removeClass("hidden");
    }
  }

  function resultsFound() {
    var allProducts = $(".prod__disp .all_products .panel_ctm");
    var collectionPost = $(
      ".prod__disp .swiper.faq_slider.collection_post .swiper-slide.panel_ctm"
    );

    var allProductsHasClass =
      allProducts.length === allProducts.filter(".ctm-shop-hidden").length;
    var collectionPostHasClass =
      collectionPost.length === collectionPost.filter(".ctm-shop-hidden").length;

    if(allProductsHasClass == true){
      $(".all_products").addClass("hidden");
    }else{
      $(".all_products").removeClass("hidden");
    }
    //.prod__disp .all_products .panel_ctm ==3  == .prod__disp .all_products .panel_ctm.ctm-shop-hidden.length = 2
    
    if(collectionPostHasClass == true){
      $(".faqs_section").addClass("hidden");
    }else{
      $(".faqs_section").removeClass("hidden");
    }
    
    if (allProductsHasClass && collectionPostHasClass) {
      $(".faqs_sectionTitle").addClass("hidden");
      $(".products_heading").addClass("hidden");
      $(".no_datas").removeClass("hidden");
    } else {
      $(".faqs_sectionTitle").removeClass("hidden");
      $(".products_heading").removeClass("hidden");
      $(".no_datas").addClass("hidden");
    }
  }

  $(document).on("click", ".suggestion_box li", function (e) {
    var searchTerm1 = $(this).text();
    $("#collection_search_bar").val(searchTerm1);
    checkInput();
    performSearch(searchTerm1);
    faqSearch(searchTerm1)
    resultsFound();
  });

  let initSearch = () => {
    $(".popup").addClass("visible").fadeIn(400);
    $(".popup").removeClass("custom_height");
      $("body").css("overflow", "hidden").addClass("search_open");  
      $(".consumer_account").hide();
      $(".popup__content").show();
      $(".cart_popup").hide();
      $("#collection_search_bar").focus();
  }

  
var searchTimeout;

$(".header-search").on("mouseenter", function () {
  searchTimeout = setTimeout(function () {
    initSearch();
  }, 500);
});

$(".header-search").on("mouseleave", function () {
  clearTimeout(searchTimeout);
});


    $(".header-search").on("click", function () {
     initSearch();
  });

  
  $("body").on("click.popupHandler", function (event) {
    if (
      !$(event.target).closest(".popup.visible").length &&
      !$(event.target).closest(".account-icon").length &&
      !$(event.target).closest(".yotpo-reviews").length
    ) {
      $(".visible").fadeOut(400);
      $(".popup").removeClass("visible custom_height");
      $("body").css("overflow", "auto").removeClass("search_open");
    }
  });

  $(".cancel_btn").on("click", function () {
    $(".visible").fadeOut(400);
    $(".popup").removeClass("visible custom_height");
    $("body").css("overflow", "auto").removeClass("search_open");
  });
  // To hide search panel when pressing escape key 
  $(document).keyup(function(e) {
     if (e.key === "Escape") { // escape key maps to keycode `27`
        $(".visible").fadeOut(400);
        $(".popup").removeClass("visible");
        $("body").css("overflow", "auto").removeClass("search_open");
       // console.log(e.key);
    }
  });

  
  $(document).on("click", ".log_in", function (e) {
$(".account-login").removeClass("hidden right_content");
  $(".account-register").addClass("hidden left_content");
  $(".sign_up").removeClass("active");
    $(".log_in").addClass("active");
  });
  
  $(document).on("click", ".sign_up", function (e) {
$(".account-login").addClass("hidden right_content");
  $(".account-register").removeClass("hidden left_content");  
     $(".sign_up").addClass("active");
    $(".log_in").removeClass("active");
  });





  
    $("#forgot_password").on("click", function () {
    $("#recover-password").removeClass('hidden');
      $("#login-customer ").hide();
  });

    $("#forgot_password").on("click", function () {
    $("#recover-password").removeClass('hidden');
      $("#login-customer ").hide();
  });

    $(".cancel_forgot").on("click", function () {
    $("#recover-password").addClass('hidden');
      $("#login-customer ").show();
  });
});
// 26-2-24 b2b quickorder start

document.addEventListener("DOMContentLoaded", function() {
    const searchIcon = document.querySelector('#search-icon');
    const searchInput = document.querySelector('#search-input');
    const resultsContainer = document.querySelector('#search-results'); // Assuming you have a container for displaying results

function performSearch() {
    const query = searchInput.value.trim().toLowerCase();

    const productBlocks = document.querySelectorAll('.product-quick-orders-block');
    let foundMatch = false;

    $('.product-quick-orders-block').each(function() {
        const productTitle = $(this).find('.left-product-content h4 a').text().toLowerCase();
        const skuElements = $(this).find('.right-product-content .orders_sku');
        let foundMatch = false;
  
        skuElements.each(function() {
            const sku = $(this).text().toLowerCase();
            if (productTitle.includes(query) || sku.includes(query)) {
                foundMatch = true;
                return false; // Exit the loop if a match is found
            }
        });
  
        if (foundMatch) {
            $(this).show(); // Display the product-quick-orders-block
        } else {
            $(this).hide(); // Hide the product-quick-orders-block
        }
    });

    resultsContainer.innerHTML = '';

    if (!$('.product-quick-orders-block:visible').length && query !== '') {
       const noProductsFoundMessage = document.createElement('p');
        noProductsFoundMessage.textContent = 'No products found';
        resultsContainer.appendChild(noProductsFoundMessage);
    }
 
}



    function debounce(func, delay) {
        let timeoutId;
        return function () {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(func, delay);
        };
    }

    searchIcon.addEventListener('click', performSearch);

    searchInput.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
            performSearch();
        }
    });

    const debouncedPerformSearch = debounce(performSearch, 300);
    searchInput.addEventListener('input', debouncedPerformSearch);
});
// 26-2-24 b2b quickorder end


      

